(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tibatoes-affirmation"] && !Shopify.designMode) return;
  try {
    
(() => {
  const controllerKey = '__ttAffirmationsControllerV16';
  if (window[controllerKey]) {
    window[controllerKey].scan(document);
    return;
  }
  const instances = new Map();
  const selector = '[data-tt-affirmations]';
  const validId = value => Number.isSafeInteger(value) && value > 0;
  const localUrl = (value, suffix) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && url.pathname.endsWith(suffix) ? url.href : null;
    } catch {
      return null;
    }
  };

  const initialize = root => {
    if (instances.has(root)) return;
    const form = root.querySelector('[data-purchase-form]');
    const configNode = root.querySelector('script[data-config]');
    if (!form || !configNode) return;
    let config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch {
      return;
    }
    if (!config || typeof config !== 'object') return;
    if (Array.isArray(config.allOffers)) {
      config.offers = config.allOffers.slice(0, 3);
      config.regular = config.allOffers[3];
    }
    const all = query => Array.from(root.querySelectorAll(query));
    const one = query => root.querySelector(query);
    const texts = config.texts || {};
    const hasDeadline = typeof config.deadline === 'string' && config.deadline.trim().length > 0;
    const deadline = Date.parse(config.deadline);
    const validDeadline = Number.isFinite(deadline);
    const deckNames = Array.isArray(config.deckNames) ? config.deckNames.filter(value => typeof value === 'string' && value.trim()) : [];
    const validDecks = deckNames.length === 3 && new Set(deckNames).size === 3;
    const offers = Array.isArray(config.offers) ? config.offers : [];
    const usesDeckVariants = config.purchaseMode === 'deck_variants';
    const deckVariants = Array.isArray(config.deckVariants) ? config.deckVariants : [];
    const currency = typeof config.currency === 'string' ? config.currency.trim().toUpperCase() : '';
    const shopCurrency = typeof config.shopCurrency === 'string' ? config.shopCurrency.trim().toUpperCase() : '';
    const moneyFormatters = new Map();
    const formatterFor = code => {
      if (moneyFormatters.has(code)) return moneyFormatters.get(code);
      let formatter = null;
      try {
        formatter = new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', { style: 'currency', currency: code });
      } catch {
        try {
          formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: code });
        } catch {}
      }
      moneyFormatters.set(code, formatter);
      return formatter;
    };
    const addUrl = localUrl(config.cartAddUrl, '/cart/add.js');
    const cartUrl = localUrl(config.cartUrl, '/cart');
    const eventController = new AbortController();
    const tierInputs = all('[data-tier]');
    const deckSelects = all('[data-deck-select]');
    const submitButtons = all('[data-submit]');
    const statuses = all('[data-form-status]');
    const sticky = one('[data-sticky]');
    const recoveries = all('[data-recovery-cart]');
    const drawerRetries = all('[data-open-cart]');
    let activePurchaseArea = form.closest('[data-purchase-area]') || form;
    let phase = !hasDeadline || (validDeadline && Date.now() < deadline) ? 'offer' : 'regular';
    let selectedCount = 1;
    let submitting = false;
    let confirmedAdd = false;
    let drawerPending = false;
    let drawerOpening = false;
    let uncertain = false;
    let destroyed = false;
    let timeout;
    let observer;
    let requestController;

    const setText = (query, value) => {
      if (typeof value !== 'string' && typeof value !== 'number') return;
      all(query).forEach(element => { element.textContent = String(value); });
    };
    const announce = message => {
      statuses.forEach(status => { status.textContent = typeof message === 'string' ? message : ''; });
    };
    const synchronizeSlot = source => {
      const slot = Number(source.dataset.slot);
      if (![1, 2, 3].includes(slot)) return;
      deckSelects.forEach(select => {
        if (select !== source && Number(select.dataset.slot) === slot) select.value = source.value;
      });
    };
    const localDeckSelect = slot => deckSelects.find(select => Number(select.dataset.slot) === slot && activePurchaseArea.contains(select));
    const selectionsFor = count => Array.from({ length: count }, (_, index) => {
      const select = deckSelects.find(element => Number(element.dataset.slot) === index + 1);
      return select && deckVariants.find(variant => variant.name === select.value);
    });
    const validPrice = price => Number.isSafeInteger(price) && price >= 0;
    const validAmount = price => typeof price === 'number' && Number.isFinite(price) && price >= 0 && price <= Number.MAX_SAFE_INTEGER;
    const validCurrency = code => /^[A-Z]{3}$/.test(code);
    const priceUnavailable = typeof texts.priceUnavailable === 'string' ? texts.priceUnavailable : 'Price unavailable';
    const formatPrice = (price, code = currency) => {
      if (!validAmount(price) || !validCurrency(code)) return null;
      const formatter = formatterFor(code);
      return formatter ? formatter.format(price / 100) : `${code === 'USD' ? 'US$' : `${code} `}${(price / 100).toFixed(currencyDecimals(code))}`;
    };
    const currencyDecimals = (code = currency) => {
      const formatter = formatterFor(code);
      if (formatter) return formatter.resolvedOptions().maximumFractionDigits;
      if (/^(BIF|CLP|DJF|GNF|ISK|JPY|KMF|KRW|PYG|RWF|UGX|UYI|VND|VUV|XAF|XOF|XPF)$/.test(code)) return 0;
      if (/^(BHD|IQD|JOD|KWD|LYD|OMR|TND)$/.test(code)) return 3;
      return code === 'CLF' || code === 'UYW' ? 4 : 2;
    };
    const decimals = currencyDecimals();
    const subunitScale = 10 ** decimals;
    const productId = value => {
      const match = String(value == null ? '' : value).match(/^(?:gid:\/\/shopify\/Product\/)?([1-9]\d*)$/);
      return match ? match[1] : null;
    };
    const configuredProductId = productId(config.productId);
    const configuredDealId = typeof config.kachingDealId === 'string' ? config.kachingDealId.trim() : '';
    const readPricing = () => {
      const tiers = {};
      [2, 3].forEach(count => {
        const value = config.tierDiscounts && config.tierDiscounts[count];
        tiers[count] = { type: 'amount', value: typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : 0 };
      });
      let roundCents = config.priceRounding === true && Number.isInteger(config.roundingCents) && config.roundingCents >= 0 && config.roundingCents <= 99 ? config.roundingCents : null;
      const matches = [];
      document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(node => {
        try {
          const data = JSON.parse(node.textContent);
          if (!data || !Array.isArray(data.dealBars)) return;
          const exactDeal = configuredDealId && String(data.id == null ? '' : data.id) === configuredDealId;
          const includedIds = data.blockVisibility === 'selected-products' && Array.isArray(data.selectedProductIds) ? data.selectedProductIds : [];
          const matchingProduct = configuredProductId && productId(node.dataset.productId) === configuredProductId && includedIds.some(id => productId(id) === configuredProductId);
          if (exactDeal || matchingProduct) matches.push({ data, priority: exactDeal ? 2 : 1 });
        } catch {}
      });
      matches.sort((a, b) => b.priority - a.priority);
      for (const { data } of matches) {
        let matchedTier = false;
        data.dealBars.forEach(bar => {
          if (!bar || ![2, 3].includes(Number(bar.quantity))) return;
          const count = Number(bar.quantity);
          const value = typeof bar.discountValue === 'number' || typeof bar.discountValue === 'string' && bar.discountValue.trim() ? Number(bar.discountValue) : NaN;
          if (!Number.isFinite(value) || value < 0 || !['amount', 'percentage'].includes(bar.discountType) || bar.discountType === 'percentage' && value > 100) return;
          tiers[count] = { type: bar.discountType, value };
          matchedTier = true;
        });
        if (!matchedTier) continue;
        if (data.priceRounding === false) roundCents = null;
        else if (data.priceRounding === true) {
          const match = String(data.priceRoundingPrecision || '').match(/\.(\d{2})/);
          if (match) roundCents = Number(match[1]);
        }
        break;
      }
      let rate = null;
      if (validCurrency(shopCurrency) && currency === shopCurrency) rate = 1;
      else {
        const shopifyCurrency = window.Shopify && window.Shopify.currency;
        const currentCurrency = shopifyCurrency && typeof shopifyCurrency.active === 'string' ? shopifyCurrency.active.toUpperCase() : '';
        const candidate = shopifyCurrency && (typeof shopifyCurrency.rate === 'number' || typeof shopifyCurrency.rate === 'string' && shopifyCurrency.rate.trim()) ? Number(shopifyCurrency.rate) : NaN;
        if (validCurrency(shopCurrency) && currentCurrency === currency && Number.isFinite(candidate) && candidate > 0) rate = candidate;
      }
      return { tiers, roundCents, rate };
    };
    let pricing = readPricing();
    let pricingSignature = JSON.stringify(pricing);
    const discountedPrice = (subtotal, count) => {
      const tier = phase === 'offer' && pricing.tiers[count];
      if (!tier || tier.value <= 0) return subtotal;
      let off;
      if (tier.type === 'percentage') off = Math.round(subtotal * subunitScale / 100 * tier.value / 100) * 100 / subunitScale;
      else {
        if (pricing.rate == null) return subtotal;
        off = Math.round(tier.value * pricing.rate * subunitScale) * 100 / subunitScale * count;
      }
      if (!validAmount(off)) return subtotal;
      let total = Math.max(0, Math.round((subtotal - off) * subunitScale / 100) * 100 / subunitScale);
      if (total > 0 && off > 0 && decimals === 2 && pricing.roundCents != null) total = Math.floor((total + 1e-8) / 100) * 100 + pricing.roundCents;
      return Math.min(subtotal, Math.max(0, Math.round(total * subunitScale / 100) * 100 / subunitScale));
    };
    const offerFor = count => {
      const base = phase === 'offer' ? offers.find(offer => offer.sets === count) : count === 1 ? config.regular : null;
      if (!usesDeckVariants || !base) return base;
      const chosen = selectionsFor(count);
      const merchandise = chosen[0];
      const hasPrice = chosen.length === count && chosen.every(variant => variant && validPrice(variant.price)) && validCurrency(currency);
      const subtotal = hasPrice ? chosen.reduce((sum, variant) => sum + variant.price, 0) : null;
      const price = hasPrice && validAmount(subtotal) ? discountedPrice(subtotal, count) : null;
      const available = validAmount(price) && chosen.every(variant => validId(variant.id) && variant.available === true && (!variant.sellingPlanId || validId(variant.sellingPlanId)));
      const unitPrice = hasPrice ? formatPrice(Math.round(price / count)) : null;
      const unitText = unitPrice && typeof texts.perSet === 'string' ? texts.perSet.replace(/\[price\]|\{\{\s*price\s*\}\}|\{price\}/g, unitPrice) : unitPrice ? `${unitPrice} / set` : '';
      return {
        ...base,
        sets: count,
        id: merchandise && merchandise.id,
        available,
        price,
        priceText: validAmount(price) ? formatPrice(price) || priceUnavailable : priceUnavailable,
        unitText,
        regularPrice: count === 1 ? merchandise && merchandise.regularPrice : hasPrice ? chosen.reduce((sum, variant) => sum + (validPrice(variant.regularPrice) && variant.regularPrice > variant.price ? variant.regularPrice : variant.price), 0) : null,
        sellingPlanId: merchandise && merchandise.sellingPlanId
      };
    };
    const currentOffer = () => offerFor(selectedCount);
    const usableOffer = offer => Boolean(offer && validId(offer.id) && offer.sets === selectedCount && offer.available === true && validAmount(offer.price) && typeof offer.priceText === 'string' && (!offer.sellingPlanId || validId(offer.sellingPlanId)));
    const ready = () => config.enabled === true && (!hasDeadline || validDeadline) && validDecks && Boolean(addUrl && cartUrl) && usableOffer(currentOffer()) && validCurrency(currency);
    const browsableOffer = offer => Boolean(offer && (usesDeckVariants || (validId(offer.id) && offer.available === true)));
    const updatePhase = () => {
      if (hasDeadline && validDeadline && phase === 'offer' && Date.now() >= deadline) {
        phase = 'regular';
        selectedCount = 1;
        return true;
      }
      return false;
    };
    const showCountdown = () => {
      if (!hasDeadline) {
        setText('[data-countdown]', '');
        return;
      }
      if (!validDeadline) {
        setText('[data-countdown]', texts.unavailable);
        return;
      }
      if (phase !== 'offer') {
        setText('[data-countdown]', texts.expired);
        return;
      }
      const minutes = Math.max(0, Math.ceil((deadline - Date.now()) / 60000));
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      const remainder = minutes % 60;
      setText('[data-countdown]', `${texts.countdown || ''} ${days}${texts.day || 'd'} ${hours}${texts.hour || 'h'} ${remainder}${texts.minute || 'm'}`.trim());
    };
    const renderComparison = (container, offer) => {
      const comparison = container.matches('[data-offer-comparison]') ? container : container.querySelector('[data-offer-comparison]');
      if (!comparison) return;
      const hasComparison = offer && validAmount(offer.price) && validAmount(offer.regularPrice) && offer.regularPrice > offer.price;
      const oldText = hasComparison ? formatPrice(offer.regularPrice) : null;
      const savingText = hasComparison ? formatPrice(offer.regularPrice - offer.price) : null;
      const visible = Boolean(oldText && savingText);
      comparison.hidden = !visible;
      const oldPrice = comparison.querySelector('[data-offer-old-price]');
      const savingAmount = comparison.querySelector('[data-offer-saving-amount]');
      if (oldPrice) oldPrice.textContent = visible ? oldText : '';
      if (savingAmount) savingAmount.textContent = visible ? savingText : '';
    };
    const selectedGiftBags = () => {
      const widget = root.querySelector('tt-gift-bag');
      const bags = widget && typeof widget.getSelections === 'function' ? widget.getSelections() : [];
      return Array.isArray(bags) ? bags.filter(bag => validId(Number(bag.id)) && Number.isSafeInteger(bag.quantity) && bag.quantity > 0 && bag.quantity <= 99 && validAmount(bag.price)).map(bag => ({ id: Number(bag.id), quantity: bag.quantity, price: bag.price, compare: Math.max(bag.price, Number(bag.compare) || 0) })) : [];
    };
    const render = () => {
      if (destroyed) return;
      const offer = currentOffer();
      const isOfferActive = phase === 'offer';
      const canPurchase = ready() && !submitting && !uncertain && !drawerOpening;
      root.dataset.offerPhase = phase;
      root.dataset.purchaseReady = ready() ? 'true' : 'false';
      all('[data-offer-only]').forEach(element => { element.hidden = !isOfferActive; });
      all('[data-regular-only]').forEach(element => { element.hidden = isOfferActive; });
      const selectedFirst = usesDeckVariants ? selectionsFor(1)[0] : null;
      all('[data-deck-choice]').forEach(button => {
        button.setAttribute('aria-pressed', selectedFirst && selectedFirst.name === button.dataset.deckChoice ? 'true' : 'false');
        button.disabled = submitting || uncertain || drawerOpening;
      });
      all('[data-deck-single]').forEach(element => { element.hidden = selectedCount !== 1; });
      all('[data-deck-multiple]').forEach(element => { element.hidden = selectedCount === 1; });
      const comparisonPrice = selectedFirst && selectedFirst.regularPrice;
      const showComparison = isOfferActive && selectedFirst && validPrice(selectedFirst.price) && validPrice(comparisonPrice) && comparisonPrice > selectedFirst.price;
      setText('[data-regular-price]', usesDeckVariants ? showComparison ? formatPrice(comparisonPrice) || '' : '' : config.regular && config.regular.priceText);
      all('[data-regular-comparison]').forEach(element => { element.hidden = !showComparison; });
      setText('[data-price-currency]', currency);
      all('[data-currency-note]').forEach(element => { element.hidden = true; element.textContent = ''; });
      all('[data-summary-price]').forEach(element => {
        const count = Number(element.dataset.count || element.dataset.summaryPrice);
        const summaryOffer = offerFor(count);
        if (summaryOffer && typeof summaryOffer.priceText === 'string') element.textContent = summaryOffer.priceText;
      });
      all('[data-pick-tier]').forEach(button => {
        const count = Number(button.dataset.count || button.value || button.dataset.pickTier);
        const tier = offerFor(count);
        button.disabled = submitting || uncertain || !browsableOffer(tier);
        button.dataset.selected = count === selectedCount ? 'true' : 'false';
        button.setAttribute('aria-pressed', count === selectedCount ? 'true' : 'false');
        renderComparison(button, tier);
      });
      all('[data-tier-card]').forEach(card => {
        const count = Number(card.dataset.count);
        const tier = offerFor(count);
        card.hidden = !isOfferActive && count !== 1;
        card.dataset.selected = count === selectedCount ? 'true' : 'false';
        card.dataset.available = tier && validId(tier.id) && tier.available === true ? 'true' : 'false';
        const price = card.querySelector('[data-tier-price]');
        const unit = card.querySelector('[data-tier-unit]');
        if (price && tier && typeof tier.priceText === 'string') price.textContent = tier.priceText;
        if (unit && tier && typeof tier.unitText === 'string') unit.textContent = tier.unitText;
        const comparison = card.querySelector('[data-tier-comparison]');
        const regularPrice = card.querySelector('[data-tier-regular-price]');
        const hasComparison = isOfferActive && tier && validAmount(tier.price) && validPrice(tier.regularPrice) && tier.regularPrice > tier.price;
        if (comparison) comparison.hidden = !hasComparison;
        if (regularPrice) regularPrice.textContent = hasComparison ? formatPrice(tier.regularPrice) || '' : '';
        renderComparison(card, tier);
      });
      tierInputs.forEach(input => {
        const count = Number(input.value);
        const tier = offerFor(count);
        input.checked = count === selectedCount;
        input.disabled = submitting || uncertain || !browsableOffer(tier) || (!isOfferActive && count !== 1);
      });
      all('[data-slot]').forEach(slot => { slot.hidden = Number(slot.dataset.slot) > selectedCount; });
      deckSelects.forEach(select => {
        const active = Number(select.dataset.slot) <= selectedCount;
        select.disabled = !active || submitting || uncertain;
        select.required = active;
      });
      const giftBags = selectedGiftBags();
      const bagPrice = giftBags.reduce((sum, bag) => sum + bag.price * bag.quantity, 0);
      const bagCompare = giftBags.reduce((sum, bag) => sum + bag.compare * bag.quantity, 0);
      const combinedOffer = offer ? { ...offer, price: offer.price + bagPrice, regularPrice: (offer.regularPrice || offer.price) + bagCompare } : offer;
      all('[data-selected-comparison]').forEach(comparison => { renderComparison(comparison, combinedOffer); });
      if (offer) {
        setText('[data-price]', bagPrice ? formatPrice(combinedOffer.price) || priceUnavailable : offer.priceText);
        setText('[data-unit-price]', offer.unitText);
      }
      setText('[data-selected-count]', selectedCount);
      const variantInput = one('[data-variant-id]');
      const planInput = one('[data-selling-plan]');
      if (variantInput) {
        variantInput.value = offer && validId(offer.id) ? String(offer.id) : '';
        variantInput.disabled = !ready();
      }
      if (planInput) {
        planInput.value = offer && validId(offer.sellingPlanId) ? String(offer.sellingPlanId) : '';
        planInput.disabled = !ready() || !offer || !validId(offer.sellingPlanId);
      }
      let label = texts.buy;
      if (submitting) label = texts.adding;
      setText('[data-submit-label]', label);
      all('[data-availability-note]').forEach(element => {
        element.hidden = ready();
        element.textContent = typeof texts.orderUnavailable === 'string' ? texts.orderUnavailable : '';
      });
      submitButtons.forEach(button => { button.disabled = !canPurchase; });
      form.setAttribute('aria-busy', submitting ? 'true' : 'false');
      recoveries.forEach(recovery => {
        recovery.hidden = !uncertain;
        if (cartUrl) recovery.href = cartUrl;
      });
      drawerRetries.forEach(button => {
        button.hidden = !drawerPending;
        button.disabled = drawerOpening || submitting;
      });
      showCountdown();
    };
    const refresh = () => {
      const changed = updatePhase();
      const nextPricing = readPricing();
      const nextSignature = JSON.stringify(nextPricing);
      const pricingChanged = nextSignature !== pricingSignature;
      if (pricingChanged) {
        pricing = nextPricing;
        pricingSignature = nextSignature;
      }
      if (changed || pricingChanged) {
        render();
        if (changed && !submitting && !uncertain) announce(texts.changed);
      } else {
        showCountdown();
      }
      return changed;
    };
    const changeTier = event => {
      const input = event.target.closest('[data-tier]');
      if (!input || !root.contains(input) || submitting || uncertain) return;
      if (refresh()) return;
      const count = Number(input.value);
      if (![1, 2, 3].includes(count) || (phase !== 'offer' && count !== 1)) return;
      const offer = offerFor(count);
      if (!browsableOffer(offer)) return;
      selectedCount = count;
      announce('');
      render();
    };
    let showDeckGallery = () => {};
    const changeDeck = event => {
      const select = event.target.closest('[data-deck-select]');
      if (!select || !root.contains(select) || submitting || uncertain) return;
      synchronizeSlot(select);
      showDeckGallery(select.value);
      refresh();
      announce('');
      render();
    };
    const chooseDeck = event => {
      const button = event.target.closest('[data-deck-choice]');
      if (!button || !root.contains(button) || submitting || uncertain || drawerOpening) return;
      const first = deckSelects.find(select => Number(select.dataset.slot) === 1);
      if (!first || !deckNames.includes(button.dataset.deckChoice)) return;
      first.value = button.dataset.deckChoice;
      changeDeck({ target: first });
    };
    const pickDeck = event => {
      const button = event.target.closest('[data-pick-deck]');
      if (!button || !root.contains(button) || submitting || uncertain) return;
      const value = button.value || button.dataset.pickDeck;
      const first = deckSelects.find(select => Number(select.dataset.slot) === 1);
      if (!first || !deckNames.includes(value)) return;
      first.value = value;
      first.dispatchEvent(new Event('change', { bubbles: true }));
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      first.focus({ preventScroll: true });
    };
    const pickTier = event => {
      const button = event.target.closest('[data-pick-tier]');
      if (!button || !root.contains(button) || submitting || uncertain) return;
      const count = Number(button.dataset.count || button.value || button.dataset.pickTier);
      const input = tierInputs.find(element => Number(element.value) === count);
      if (!input || input.disabled) return;
      changeTier({ target: input });
    };
    const gallery = one('[data-gallery]');
    if (gallery) {
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const countLabel = gallery.querySelector('[data-gallery-count]');
      let galleryIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
      let pointerStart = null;
      const showSlide = index => {
        if (!slides.length) return;
        galleryIndex = (index + slides.length) % slides.length;
        const selected = slides[galleryIndex];
        slides.forEach((slide, position) => {
          slide.hidden = position !== galleryIndex;
          slide.setAttribute('aria-hidden', position === galleryIndex ? 'false' : 'true');
        });
        thumbs.forEach(thumb => {
          const active = thumb.dataset.galleryThumb === selected.dataset.gallerySlide;
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (countLabel) countLabel.textContent = `${galleryIndex + 1} / ${slides.length}`;
      };
      showDeckGallery = name => {
        const choice = all('[data-deck-choice]').find(button => button.dataset.deckChoice === name);
        if (!choice) return;
        const mediaId = choice.dataset.deckMedia;
        const index = slides.findIndex(slide => mediaId && slide.dataset.galleryMedia === mediaId);
        if (index >= 0) showSlide(index);
      };
      gallery.addEventListener('click', event => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (thumb) {
          const index = slides.findIndex(slide => slide.dataset.gallerySlide === thumb.dataset.galleryThumb);
          if (index >= 0) showSlide(index);
        } else if (event.target.closest('[data-gallery-prev]')) showSlide(galleryIndex - 1);
        else if (event.target.closest('[data-gallery-next]')) showSlide(galleryIndex + 1);
      }, { signal: eventController.signal });
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.matches('input, textarea, select')) return;
        event.preventDefault();
        showSlide(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal: eventController.signal });
      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.target.closest('[data-gallery-slide]') || event.target.closest('a, button, input, select, textarea')) return;
        pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { signal: eventController.signal });
      gallery.addEventListener('pointerup', event => {
        if (!pointerStart || pointerStart.id !== event.pointerId) return;
        const dx = event.clientX - pointerStart.x;
        const dy = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) showSlide(galleryIndex + (dx < 0 ? 1 : -1));
      }, { signal: eventController.signal });
      gallery.addEventListener('pointercancel', () => { pointerStart = null; }, { signal: eventController.signal });
      showSlide(galleryIndex);
    }
    const peekDialog = one('[data-peek-dialog]');
    const peekConfigNode = one('script[data-peek-config]');
    let peekConfig;
    try {
      peekConfig = peekConfigNode ? JSON.parse(peekConfigNode.textContent) : null;
    } catch {
      peekConfig = null;
    }
    const peekDecks = peekConfig && Array.isArray(peekConfig.decks) ? peekConfig.decks.map(deck => ({
      key: deck.key,
      name: deck.name,
      cards: Array.isArray(deck.cards) ? deck.cards.filter(card => card && typeof card.src === 'string' && card.src.trim()).slice(0, 8) : []
    })).filter(deck => typeof deck.key === 'string' && typeof deck.name === 'string' && deck.cards.length) : [];
    const peekTexts = peekConfig && peekConfig.texts ? peekConfig.texts : {};
    const peekImage = one('[data-peek-image]');
    const peekThumbs = one('[data-peek-thumbs]');
    const peekTabs = all('[data-peek-tab]');
    let peekDeck = peekDecks[0];
    let peekIndex = 0;
    let peekOpener;
    const renderPeek = rebuild => {
      if (!peekDeck || !peekImage || !peekThumbs) return;
      const card = peekDeck.cards[peekIndex];
      peekImage.src = card.src;
      peekImage.alt = typeof card.alt === 'string' ? card.alt : peekDeck.name;
      peekImage.dataset.code = typeof card.code === 'string' ? card.code : '';
      setText('[data-peek-title]', peekDeck.name);
      const activeTab = peekTabs.find(button => button.value === peekDeck.key);
      const panel = one('[data-peek-panel]');
      if (panel && activeTab && activeTab.id) panel.setAttribute('aria-labelledby', activeTab.id);
      const counter = String(peekTexts.count || '[current] / [total]')
        .replace('[current]', String(peekIndex + 1))
        .replace('[total]', String(peekDeck.cards.length));
      setText('[data-peek-count]', counter);
      peekTabs.forEach(button => {
        const active = button.value === peekDeck.key;
        button.disabled = !peekDecks.some(deck => deck.key === button.value);
        button.dataset.active = String(active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      all('[data-peek-prev], [data-peek-next]').forEach(button => { button.disabled = peekDeck.cards.length < 2; });
      if (rebuild) {
        const fragment = document.createDocumentFragment();
        peekDeck.cards.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.peekThumb = String(index);
          button.setAttribute('aria-label', `${peekTexts.thumbnail || 'Preview card'} ${index + 1}: ${item.alt || item.code || peekDeck.name}`);
          const image = document.createElement('img');
          image.src = item.src;
          image.alt = '';
          image.width = 70;
          image.height = 120;
          image.loading = 'lazy';
          button.append(image);
          fragment.append(button);
        });
        peekThumbs.replaceChildren(fragment);
      }
      peekThumbs.querySelectorAll('[data-peek-thumb]').forEach(button => {
        const active = Number(button.dataset.peekThumb) === peekIndex;
        button.dataset.active = String(active);
        button.setAttribute('aria-pressed', String(active));
      });
    };
    const changePeekCard = direction => {
      if (!peekDeck) return;
      peekIndex = (peekIndex + direction + peekDeck.cards.length) % peekDeck.cards.length;
      renderPeek(false);
    };
    const openPeek = event => {
      const opener = event.target.closest('[data-peek-open]');
      if (!opener || !root.contains(opener) || !peekDialog || !peekImage || !peekThumbs || !peekDecks.length || typeof peekDialog.showModal !== 'function') return;
      let key = opener.value || opener.dataset.peekOpen;
      if (key === 'selected') {
        const first = deckSelects.find(select => Number(select.dataset.slot) === 1);
        const chosen = first && (peekDecks.find(deck => deck.name === first.value) || peekDecks[deckNames.indexOf(first.value)]);
        key = chosen ? chosen.key : peekDecks[0].key;
      }
      peekDeck = peekDecks.find(deck => deck.key === key) || peekDecks[0];
      peekIndex = 0;
      peekOpener = opener;
      renderPeek(true);
      if (!peekDialog.open) peekDialog.showModal();
    };
    if (peekDialog) {
      peekDialog.addEventListener('click', event => {
        const close = event.target.closest('[data-peek-close]');
        if (close) {
          peekDialog.close();
          return;
        }
        const tab = event.target.closest('[data-peek-tab]');
        if (tab) {
          const deck = peekDecks.find(item => item.key === tab.value);
          if (deck) {
            peekDeck = deck;
            peekIndex = 0;
            renderPeek(true);
          }
          return;
        }
        const thumb = event.target.closest('[data-peek-thumb]');
        if (thumb && peekDeck) {
          const index = Number(thumb.dataset.peekThumb);
          if (Number.isInteger(index) && index >= 0 && index < peekDeck.cards.length) {
            peekIndex = index;
            renderPeek(false);
          }
          return;
        }
        if (event.target.closest('[data-peek-prev]')) changePeekCard(-1);
        else if (event.target.closest('[data-peek-next]')) changePeekCard(1);
        else if (event.target === peekDialog) {
          const box = peekDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) peekDialog.close();
        }
      }, { signal: eventController.signal });
      peekDialog.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.matches('input, textarea, select')) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const tab = event.target.closest('[data-peek-tab]');
        if (tab && peekDeck) {
          const deckIndex = peekDecks.findIndex(deck => deck.key === peekDeck.key);
          peekDeck = peekDecks[(deckIndex + direction + peekDecks.length) % peekDecks.length];
          peekIndex = 0;
          renderPeek(true);
          const active = peekTabs.find(button => button.value === peekDeck.key);
          if (active) active.focus();
        } else {
          changePeekCard(direction);
        }
      }, { signal: eventController.signal });
      peekDialog.addEventListener('close', () => {
        if (!destroyed && peekOpener && peekOpener.isConnected) peekOpener.focus({ preventScroll: true });
      }, { signal: eventController.signal });
    }
    const hasKachingDrawer = () => typeof window.kachingCartApi?.openCart === 'function';
    const nativeDrawer = () => {
      const drawer = document.querySelector('cart-drawer');
      return drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function' ? drawer : null;
    };
    const drawerSections = drawer => [...new Set(drawer.getSectionsToRender().map(section => section.id))]
      .filter(id => typeof id === 'string' && /^[\w-]+$/.test(id)).slice(0, 5);
    const openCartDrawer = async (payload, trigger, cartReady = false) => {
      if (destroyed) return false;
      if (hasKachingDrawer()) {
        document.dispatchEvent(new CustomEvent('kaching-cart:open', {
          bubbles: true,
          cancelable: true,
          detail: { refetchCart: !cartReady, element: trigger, cartOpenSource: 'add-to-cart' }
        }));
        return true;
      }
      const drawer = nativeDrawer();
      if (!drawer) return false;
      const sections = drawerSections(drawer);
      if (!sections.length) return false;
      const complete = state => sections.every(id => typeof state?.sections?.[id] === 'string' && state.sections[id].trim());
      if (!complete(payload)) {
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('sections', sections.join(','));
        const response = await fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: requestController.signal });
        if (!response.ok) return false;
        payload = { sections: await response.json() };
      }
      if (destroyed || !complete(payload)) return false;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents(payload);
      return true;
    };
    const finishAdded = opened => {
      if (destroyed) return;
      submitting = false;
      drawerPending = !opened;
      updatePhase();
      render();
      announce(opened ? texts.added : texts.drawerError);
    };
    const retryDrawer = async event => {
      const button = event.target.closest('[data-open-cart]');
      if (!button || !root.contains(button) || !confirmedAdd || !drawerPending || drawerOpening || submitting || destroyed) return;
      event.preventDefault();
      drawerOpening = true;
      render();
      requestController = new AbortController();
      timeout = window.setTimeout(() => requestController.abort(), 20000);
      try {
        finishAdded(await openCartDrawer(null, button));
      } catch {
        if (!destroyed) finishAdded(false);
      } finally {
        drawerOpening = false;
        window.clearTimeout(timeout);
        if (!destroyed) render();
      }
    };
    const markUncertain = () => {
      uncertain = true;
      submitting = false;
      render();
      announce(texts.network);
      const recovery = recoveries.find(link => activePurchaseArea.contains(link));
      if (recovery) recovery.focus({ preventScroll: true });
    };
    const submit = async event => {
      event.preventDefault();
      if (destroyed || submitting || uncertain || drawerOpening) return;
      const origin = event.submitter || document.activeElement;
      if (origin && root.contains(origin)) activePurchaseArea = origin.closest('[data-purchase-area]') || form.closest('[data-purchase-area]') || form;
      if (refresh()) {
        announce(texts.changed);
        return;
      }
      if (!ready()) {
        render();
        announce(texts.unavailable);
        return;
      }
      for (let slot = 1; slot <= selectedCount; slot += 1) {
        const select = deckSelects.find(element => Number(element.dataset.slot) === slot);
        if (!select || !deckNames.includes(select.value)) {
          announce(texts.selection);
          const localSelect = localDeckSelect(slot);
          if (localSelect) localSelect.focus({ preventScroll: true });
          return;
        }
      }
      if (!form.checkValidity()) {
        announce(texts.selection);
        const invalidLocal = deckSelects.find(select => activePurchaseArea.contains(select) && !select.disabled && !select.checkValidity());
        if (invalidLocal) invalidLocal.focus({ preventScroll: true });
        return;
      }
      const offer = currentOffer();
      const chosenVariants = usesDeckVariants ? selectionsFor(selectedCount) : [];
      const properties = {
        '_Campaign': config.campaignId
      };
      const items = [];
      const chosenItems = usesDeckVariants ? chosenVariants : [offer];
      chosenItems.forEach(variant => {
        const sellingPlan = validId(variant.sellingPlanId) ? variant.sellingPlanId : null;
        const existing = items.find(item => item.id === variant.id && (item.selling_plan || null) === sellingPlan);
        if (existing) existing.quantity += 1;
        else {
          const item = { id: variant.id, quantity: 1, properties: { ...properties } };
          if (sellingPlan) item.selling_plan = sellingPlan;
          items.push(item);
        }
      });
      selectedGiftBags().forEach(bag => items.push({ id: bag.id, quantity: bag.quantity }));
      confirmedAdd = false;
      drawerPending = false;
      submitting = true;
      announce('');
      render();
      requestController = new AbortController();
      timeout = window.setTimeout(() => requestController.abort(), 20000);
      try {
        const requestUrl = new URL(addUrl);
        const body = { items };
        const kachingHandled = hasKachingDrawer();
        if (kachingHandled) {
          requestUrl.searchParams.set('opens_cart', 'never');
        } else {
          const drawer = nativeDrawer();
          const sections = drawer && drawerSections(drawer);
          if (sections && sections.length) {
            body.sections = sections;
            body.sections_url = window.location.pathname;
          }
        }
        const response = await fetch(requestUrl.href, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          signal: requestController.signal
        });
        if (destroyed) return;
        if (response.ok) {
          confirmedAdd = true;
          let payload = null;
          try { payload = await response.json(); } catch {}
          finishAdded(await openCartDrawer(payload, origin, kachingHandled));
          return;
        }
        if (response.status >= 500) {
          markUncertain();
          return;
        }
        let message = texts.error;
        try {
          const payload = await response.json();
          if (typeof payload.description === 'string') message = payload.description;
          else if (typeof payload.message === 'string') message = payload.message;
        } catch {}
        submitting = false;
        updatePhase();
        render();
        announce(message);
      } catch {
        if (!destroyed) {
          if (confirmedAdd) finishAdded(false);
          else markUncertain();
        }
      } finally {
        window.clearTimeout(timeout);
      }
    };

    root.addEventListener('tt:gift-bag-change', render, { signal: eventController.signal });
    form.addEventListener('submit', submit, { signal: eventController.signal });
    root.addEventListener('change', changeTier, { signal: eventController.signal });
    root.addEventListener('change', changeDeck, { signal: eventController.signal });
    root.addEventListener('click', pickDeck, { signal: eventController.signal });
    root.addEventListener('click', chooseDeck, { signal: eventController.signal });
    root.addEventListener('click', pickTier, { signal: eventController.signal });
    root.addEventListener('click', openPeek, { signal: eventController.signal });
    root.addEventListener('click', retryDrawer, { signal: eventController.signal });
    window.addEventListener('pageshow', event => {
      if (event.persisted && confirmedAdd && !uncertain) {
        confirmedAdd = false;
        submitting = false;
        refresh();
        render();
      } else {
        refresh();
      }
    }, { signal: eventController.signal });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, { signal: eventController.signal });
    if (sticky) {
      sticky.hidden = true;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          for (const entry of entries) sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        }, { threshold: 0 });
        observer.observe(root.querySelector('.tt-aff__hero') || form);
      }
    }
    const interval = window.setInterval(refresh, 1000);
    instances.set(root, () => {
      destroyed = true;
      eventController.abort();
      if (peekDialog && peekDialog.open) peekDialog.close();
      if (observer) observer.disconnect();
      if (requestController) requestController.abort();
      window.clearInterval(interval);
      window.clearTimeout(timeout);
      instances.delete(root);
    });
    [1, 2, 3].forEach(slot => {
      const primary = deckSelects.find(select => Number(select.dataset.slot) === slot);
      if (primary) synchronizeSlot(primary);
    });
    render();
  };
  const scan = scope => {
    if (scope.matches && scope.matches(selector)) initialize(scope);
    scope.querySelectorAll(selector).forEach(initialize);
  };
  window[controllerKey] = { scan };
  document.addEventListener('shopify:section:load', event => { scan(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) {
      if (root === event.target || event.target.contains(root)) dispose();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { scan(document); }, { once: true });
  else scan(document);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tibatoes-gift-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tt-gift-guide')) {
  customElements.define('tt-gift-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.grid = this.querySelector('[data-gift-grid]');
      this.ssrCards = [...this.grid.children];
      this.pagination = this.querySelector('[data-gift-pagination]');
      this.ssr = this.querySelector('[data-gift-ssr]');
      this.ageButtons = [...this.querySelectorAll('[data-gift-age]')];
      this.interest = this.querySelector('[data-gift-interest]');
      this.type = this.querySelector('[data-gift-type]');
      this.budget = this.querySelector('[data-gift-budget]');
      this.budgetInput = this.querySelector('[data-gift-budget-input]');
      this.count = this.querySelector('[data-gift-count]');
      this.ssrCount = this.count.textContent;
      this.empty = this.querySelector('[data-gift-empty]');
      this.more = this.querySelector('[data-gift-more-wrap]');
      this.loadStatus = this.querySelector('[data-gift-load-status]');
      this.loadMessage = this.querySelector('[data-gift-load-message]');
      this.retry = this.querySelector('[data-gift-retry]');
      this.strings = Object.fromEntries([...this.querySelectorAll('[data-gift-strings] [data-string]')].map(node => [node.dataset.string, node.textContent]));
      this.purchases ||= new Map();
      this.hydratePurchases();
      this.bindGiftReady(options);
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-gift-option]');
        if (select && this.contains(select)) this.changeChoice(select);
      }, options);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gift-add],[data-gift-choice-retry],[data-gift-drawer-retry]');
        if (!button || !this.contains(button)) return;
        const card = button.closest('[data-gift-card]');
        const purchaseState = this.purchases.get(card?.dataset.id);
        if (!purchaseState) return;
        event.preventDefault();
        if (button.hasAttribute('data-gift-add')) this.startGiftReady(purchaseState, button);
        else if (button.hasAttribute('data-gift-choice-retry')) this.resolveChoice(purchaseState);
        else this.retryDrawer(purchaseState, button);
      }, options);
      this.ageButtons.forEach(button => button.addEventListener('click', () => {
        this.state.age = button.dataset.giftAge;
        this.commit();
      }, options));
      this.querySelector('[data-gift-bundles]').addEventListener('click', () => { this.state.type = this.state.type === 'bundle' ? 'all' : 'bundle'; this.commit(); }, options);
      this.interest.addEventListener('change', () => { this.state.interest = this.interest.value; this.commit(); }, options);
      this.type.addEventListener('change', () => { this.state.type = this.type.value; this.commit(); }, options);
      this.bindBudget(options);
      this.querySelectorAll('[data-gift-reset]').forEach(button => button.addEventListener('click', () => {
        Object.assign(this.state, { age: 'all', interest: 'all', type: 'all', budget: null });
        this.commit();
        if (button.closest('[data-gift-empty]')) this.ageButtons[0].focus();
      }, options));
      this.querySelector('[data-gift-more]').addEventListener('click', () => {
        this.state.shown += 24;
        this.writeUrl();
        this.render();
      }, options);
      this.retry.addEventListener('click', () => this.loadCatalog(), options);
      window.addEventListener('popstate', () => { this.readUrl(); this.update(); }, options);
      this.querySelector('[data-gift-filters]').hidden = false;
      this.querySelectorAll('[data-gift-js-only]').forEach(node => { node.hidden = false; });
      this.readUrl();
      if (this.catalog) this.render();
      else if (this.hasFilters()) this.loadCatalog();
      else if ('requestIdleCallback' in window) this.idle = window.requestIdleCallback(() => this.loadCatalog(), { timeout: 2000 });
      else this.idleTimeout = window.setTimeout(() => this.loadCatalog(), 1500);
    }
    bindBudget(options) {
      const budgetControl = this.budget || this.budgetInput;
      const captureBudget = () => {
        const raw = budgetControl.value;
        this.state.budget = raw === '' ? null : Number(raw) / (this.budget ? 100 : 1);
        if (!Number.isFinite(this.state.budget) || this.state.budget < 0) this.state.budget = null;
      };
      budgetControl?.addEventListener('change', () => {
        captureBudget();
        this.commit();
      }, options);
      this.budgetInput?.addEventListener('input', () => {
        captureBudget();
        window.clearTimeout(this.budgetTimer);
        this.budgetTimer = window.setTimeout(() => this.commit(), 250);
      }, options);
    }
    disconnectedCallback() {
      this.closeGiftReady(true);
      this.controller?.abort();
      this.requestController?.abort();
      if (this.idle && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.idle);
      window.clearTimeout(this.idleTimeout);
      window.clearTimeout(this.budgetTimer);
      this.budgetTimer = null;
      this.controller = null;
      this.loading = false;
      this.requestGeneration = (this.requestGeneration || 0) + 1;
      this.purchases?.forEach(state => {
        state.controller?.abort();
        state.generation += 1;
        if (state.phase === 'loading') state.phase = 'error';
      });
    }
    readUrl() {
      window.clearTimeout(this.budgetTimer);
      this.budgetTimer = null;
      const params = new URL(window.location.href).searchParams;
      const permitted = (control, value) => [...control.options].some(option => option.value === value) ? value : 'all';
      const rawBudget = params.get('budget');
      let budget = rawBudget === null || rawBudget === '' ? null : Number(rawBudget);
      if (!Number.isFinite(budget) || budget < 0) budget = null;
      if (this.budget && budget !== null && ![...this.budget.options].some(option => Number(option.value) === Math.round(budget * 100))) budget = null;
      const age = params.get('age');
      const requestedPage = Number(params.get(this.ssr.dataset.pageParam));
      const page = Number.isFinite(requestedPage) ? Math.min(42, Math.max(1, Math.floor(requestedPage))) : 1;
      const requestedShown = Number(params.get('shown'));
      const shown = Number.isFinite(requestedShown) ? Math.min(1000, Math.max(24, Math.floor(requestedShown))) : 24;
      this.state = {
        age: this.ageButtons.some(button => button.dataset.giftAge === age) ? age : 'all',
        interest: permitted(this.interest, params.get('interest')),
        type: permitted(this.type, params.get('type')),
        budget,
        shown,
        offset: (page - 1) * 24
      };
      if (this.hasFilters()) this.state.offset = 0;
      this.syncControls();
    }
    hasFilters() {
      return this.state.age !== 'all' || this.state.interest !== 'all' || this.state.type !== 'all' || this.state.budget !== null;
    }
    syncControls() {
      this.ageButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.giftAge === this.state.age)));
      this.interest.value = this.state.interest;
      this.type.value = this.state.type;
      this.querySelector('[data-gift-bundles]').setAttribute('aria-pressed', String(this.state.type === 'bundle'));
      if (this.budget) this.budget.value = this.state.budget === null ? '' : String(Math.round(this.state.budget * 100));
      if (this.budgetInput) this.budgetInput.value = this.state.budget === null ? '' : String(this.state.budget);
    }
    commit() {
      window.clearTimeout(this.budgetTimer);
      this.budgetTimer = null;
      this.state.shown = 24;
      this.state.offset = 0;
      this.syncControls();
      this.writeUrl();
      this.update();
    }
    writeUrl() {
      const url = new URL(window.location.href);
      for (const key of ['age', 'interest', 'type', 'budget', 'shown', this.ssr.dataset.pageParam]) url.searchParams.delete(key);
      for (const key of ['age', 'interest', 'type']) if (this.state[key] !== 'all') url.searchParams.set(key, this.state[key]);
      if (this.state.budget !== null) url.searchParams.set('budget', this.state.budget);
      if (this.state.shown > 24) url.searchParams.set('shown', this.state.shown);
      if (this.state.offset > 0) url.searchParams.set(this.ssr.dataset.pageParam, Math.floor(this.state.offset / 24) + 1);
      if (url.href !== window.location.href) window.history.pushState(window.history.state, '', url);
    }
    update() {
      if (this.catalog) this.render();
      else if (this.loading) this.showLoading();
      else this.loadCatalog();
    }
    showLoading() {
      this.loadStatus.hidden = false;
      this.loadMessage.textContent = this.strings.loading;
      this.retry.hidden = true;
      this.empty.hidden = true;
      this.more.hidden = true;
      this.grid.setAttribute('aria-busy', 'true');
      if (this.hasFilters()) {
        this.grid.hidden = true;
        this.pagination.hidden = true;
        this.count.textContent = this.strings.loading;
      }
    }
    async loadCatalog() {
      if (this.loading || this.catalog || !this.isConnected) return;
      this.loading = true;
      const generation = (this.requestGeneration || 0) + 1;
      this.requestGeneration = generation;
      this.requestController?.abort();
      this.requestController = new AbortController();
      const requestController = this.requestController;
      const timeout = window.setTimeout(() => requestController.abort(), 25000);
      this.showLoading();
      try {
        const base = new URL(this.dataset.catalogUrl, window.location.origin);
        if (base.origin !== window.location.origin || !base.pathname.includes('/collections/')) throw new Error('Invalid collection');
        let url = new URL(base);
        url.search = '';
        url.searchParams.set('view', 'gift-index');
        url.searchParams.set('section_id', 'tt-gift-catalog-data');
        const items = new Map();
        let total = null;
        let collectionId = null;
        let completed = false;
        for (let page = 1; page <= 4; page += 1) {
          if (generation !== this.requestGeneration || !this.isConnected) return;
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: requestController.signal });
          if (!response.ok) throw new Error('Catalog request failed');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const node = document.querySelector('[data-gift-catalog-json]');
          if (!node) throw new Error('Catalog data missing');
          const data = JSON.parse(node.textContent);
          if (data.version !== 1 || data.currency !== this.dataset.currency || data.country !== this.dataset.country || data.locale !== this.dataset.locale || Number(data.page) !== page || !Array.isArray(data.items)) throw new Error('Catalog context mismatch');
          if (page === 1) { total = Number(data.total); collectionId = String(data.collection_id); }
          if (Number(data.total) !== total || String(data.collection_id) !== collectionId || !Number.isInteger(total) || total > 1000 || total < 0) throw new Error('Catalog changed');
          for (const item of data.items) {
            const productUrl = new URL(item.url, window.location.origin);
            if (!item.id || productUrl.origin !== window.location.origin || !productUrl.pathname.includes('/products/') || typeof item.title !== 'string' || typeof item.available !== 'boolean' || !Number.isFinite(item.price) || item.price < 0 || !Array.isArray(item.age_groups) || !Array.isArray(item.interests)) throw new Error('Invalid gift');
            items.set(String(item.id), item);
          }
          if (!data.next_url) { completed = true; break; }
          url = new URL(data.next_url, base);
          if (url.origin !== base.origin || url.pathname !== base.pathname) throw new Error('Invalid next page');
          url.searchParams.set('view', 'gift-index');
          url.searchParams.set('section_id', 'tt-gift-catalog-data');
        }
        if (!completed || items.size !== total) throw new Error('Incomplete catalog');
        if (generation !== this.requestGeneration || !this.isConnected) return;
        this.catalog = [...items.values()];
        this.loadStatus.hidden = true;
        this.grid.removeAttribute('aria-busy');
        this.render();
      } catch (error) {
        if (generation !== this.requestGeneration || !this.isConnected) return;
        this.grid.replaceChildren(...this.ssrCards);
        this.paintPurchases();
        this.grid.hidden = false;
        this.grid.removeAttribute('aria-busy');
        this.pagination.hidden = false;
        this.count.textContent = this.ssrCount;
        this.loadStatus.hidden = false;
        this.loadMessage.textContent = this.strings.error;
        this.retry.hidden = false;
        this.empty.hidden = true;
        this.more.hidden = true;
      } finally {
        window.clearTimeout(timeout);
        if (generation === this.requestGeneration) this.loading = false;
      }
    }
    productUrl(value) {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product URL');
      return url;
    }
    validPurchase(purchase) {
      return purchase && /^\d+$/.test(String(purchase.product_id)) &&
        (purchase.variant_id === null || /^\d+$/.test(String(purchase.variant_id))) &&
        typeof purchase.available === 'boolean' && typeof purchase.requires_selling_plan === 'boolean' &&
        Number.isFinite(purchase.price) && purchase.price >= 0 && typeof purchase.price_text === 'string' &&
        Array.isArray(purchase.options) && purchase.options.length <= 3 && purchase.options.every(option =>
          typeof option.name === 'string' && Number.isInteger(option.position) && option.position >= 1 && option.position <= 3 &&
          Array.isArray(option.values) && option.values.length && option.values.every(value => /^\d+$/.test(String(value.id)) && typeof value.name === 'string' && typeof value.selected === 'boolean') &&
          option.values.filter(value => value.selected).length === 1
        );
    }
    selectedIds(purchase) {
      return [...purchase.options].sort((a, b) => a.position - b.position).map(option => String(option.values.find(value => value.selected).id));
    }
    selectionKey(url, ids) {
      return `${this.productUrl(url).pathname}|${ids.join(',')}`;
    }
    purchaseState(id, purchase, url) {
      if (this.purchases.has(String(id))) return this.purchases.get(String(id));
      if (!this.validPurchase(purchase)) return null;
      const productUrl = this.productUrl(url);
      const ids = this.selectedIds(purchase);
      const state = { id: String(id), purchase, url: productUrl.href, selectionUrl: productUrl.href, selectedIds: ids, phase: 'ready', generation: 0, cache: new Map(), result: '', message: '', drawerPending: false };
      state.cache.set(this.selectionKey(state.url, ids), purchase);
      this.purchases.set(state.id, state);
      return state;
    }
    hydratePurchases() {
      this.grid.querySelectorAll('[data-gift-card]').forEach(card => {
        const data = card.querySelector('[data-gift-purchase-json]');
        const link = card.querySelector('[data-gift-fallback]');
        if (!data || !link) return;
        try {
          const state = this.purchaseState(card.dataset.id, JSON.parse(data.textContent), link.href);
          if (state) this.paintPurchase(card, state);
        } catch {}
      });
    }
    makeElement(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    paintPurchases() {
      this.grid?.querySelectorAll('[data-gift-card]').forEach(card => {
        const state = this.purchases?.get(card.dataset.id);
        if (state) this.paintPurchase(card, state);
      });
    }
    paintState(state) {
      this.grid?.querySelectorAll('[data-gift-card]').forEach(card => {
        if (card.dataset.id === state.id) this.paintPurchase(card, state);
      });
    }
    paintPurchase(card, state) {
      const prefix = 'tt-gift-guide__';
      const make = (tag, className, text) => this.makeElement(tag, className, text);
      let wrapper = card.querySelector('[data-gift-purchase]');
      if (!wrapper) return;
      wrapper.hidden = false;
      wrapper.classList.add(`${prefix}purchase`);
      wrapper.setAttribute('aria-busy', String(state.phase === 'loading' || Boolean(state.adding)));
      let options = wrapper.querySelector('[data-gift-options]');
      if (!options) {
        options = make('div');
        options.dataset.giftOptions = '';
        wrapper.prepend(options);
      }
      options.className = `${prefix}options`;
      const sortedOptions = [...state.purchase.options].sort((a, b) => a.position - b.position);
      const signature = JSON.stringify(sortedOptions.map(option => [option.name, option.position, option.values.map(value => [value.id, value.name, value.product_url])]));
      if (options.dataset.signature !== signature) {
        const focusedPosition = options.contains(document.activeElement) ? document.activeElement.dataset.optionPosition : null;
        options.replaceChildren();
        sortedOptions.forEach(option => {
          const field = make('div', `${prefix}option`);
          const id = `GiftOption-${this.dataset.sectionId}-${state.id}-${option.position}`;
          const label = make('label', '', option.name);
          label.htmlFor = id;
          const select = make('select');
          select.id = id;
          select.dataset.giftOption = '';
          select.dataset.optionPosition = option.position;
          option.values.forEach(value => {
            const node = make('option', '', value.name);
            node.value = String(value.id);
            if (value.product_url) node.dataset.productUrl = value.product_url;
            select.append(node);
          });
          field.append(label, select);
          options.append(field);
        });
        options.dataset.signature = signature;
        if (focusedPosition) options.querySelector(`[data-option-position="${focusedPosition}"]`)?.focus();
      }
      [...options.querySelectorAll('[data-gift-option]')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).forEach((select, index) => {
        select.value = state.selectedIds[index];
        select.disabled = Boolean(this.constructor.cartBusy);
      });
      let add = wrapper.querySelector('[data-gift-add]');
      if (!add) {
        add = make('button', `${prefix}button ${prefix}card-button`);
        add.type = 'button';
        add.dataset.giftAdd = '';
        wrapper.append(add);
      }
      let status = wrapper.querySelector('[data-gift-purchase-status]');
      if (!status) {
        status = make('p', `${prefix}purchase-message`);
        status.dataset.giftPurchaseStatus = '';
        status.id = `GiftStatus-${this.dataset.sectionId}-${state.id}`;
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        const actions = make('div', `${prefix}purchase-actions`);
        actions.dataset.giftPurchaseActions = '';
        for (const [hook, key] of [['giftChoiceRetry', 'tryAgain'], ['giftDrawerRetry', 'openCart']]) {
          const button = make('button', `${prefix}text-button`, this.strings[key]);
          button.type = 'button';
          button.dataset[hook] = '';
          actions.append(button);
        }
        const cartLink = make('a', `${prefix}text-link`, this.strings.viewCart);
        cartLink.dataset.giftCartLink = '';
        cartLink.href = this.dataset.cartUrl;
        actions.append(cartLink);
        wrapper.append(status, actions);
      }
      add.setAttribute('aria-describedby', status.id);
      const purchase = state.purchase;
      const unavailable = !purchase.variant_id || !purchase.available;
      add.disabled = Boolean(this.constructor.cartBusy || state.result === 'uncertain' || state.phase !== 'ready' || unavailable || purchase.requires_selling_plan);
      add.dataset.added = String(state.result === 'added');
      add.dataset.variantId = purchase.variant_id || '';
      add.textContent = state.adding ? this.strings.adding : state.result === 'added' ? this.strings.addAnother : state.result === 'uncertain' ? this.strings.checkCart : unavailable ? this.strings.unavailable : this.strings.add;
      add.setAttribute('aria-label', [add.textContent, card.querySelector('h3')?.textContent].filter(Boolean).join(': '));
      let message = '';
      if (state.adding) message = this.strings.adding;
      else if (state.result === 'added') message = state.drawerPending ? this.strings.drawerError : this.strings.addedMessage;
      else if (state.result === 'uncertain') message = [state.message, this.strings.uncertain].filter(Boolean).join(' ');
      else if (state.phase === 'loading') message = this.strings.checking;
      else if (state.phase === 'error') message = this.strings.choiceError;
      else if (purchase.requires_selling_plan) message = this.strings.productDetails;
      else if (unavailable) message = this.strings.choiceUnavailable;
      status.textContent = message;
      status.hidden = !message;
      wrapper.querySelector('[data-gift-choice-retry]').hidden = state.phase !== 'error';
      const drawerRetry = wrapper.querySelector('[data-gift-drawer-retry]');
      drawerRetry.hidden = state.result !== 'added' || !state.drawerPending;
      drawerRetry.disabled = Boolean(state.drawerOpening || this.constructor.cartBusy);
      const cartLink = wrapper.querySelector('[data-gift-cart-link]');
      cartLink.hidden = !state.result;
      cartLink.textContent = state.result === 'uncertain' ? this.strings.checkCart : this.strings.viewCart;
      const fallback = card.querySelector('[data-gift-fallback]');
      if (fallback) {
        fallback.className = `${prefix}text-link`;
        const url = this.productUrl(state.url);
        url.searchParams.delete('option_values');
        url.searchParams.delete('section_id');
        if (purchase.variant_id) url.searchParams.set('variant', purchase.variant_id);
        else url.searchParams.delete('variant');
        fallback.href = url.href;
      }
      if (state.phase === 'ready') {
        const price = card.querySelector('[data-gift-price]');
        if (price) {
          price.replaceChildren(make('span', '', purchase.variant_id && purchase.price_text ? purchase.price_text : this.strings.unavailable));
          if (purchase.variant_id && purchase.compare_at > purchase.price && purchase.compare_at_text) price.append(make('s', '', purchase.compare_at_text));
        }
        if (purchase.image?.src) {
          const source = new URL(purchase.image.src, window.location.origin);
          if (source.protocol === 'https:' || source.origin === window.location.origin) {
            let image = card.querySelector('[data-gift-image]');
            const imageLink = card.querySelector('[data-gift-image-link]');
            if (!image && imageLink) {
              image = make('img', `${prefix}product-image`);
              image.dataset.giftImage = '';
              image.loading = 'lazy';
              image.decoding = 'async';
              image.alt = '';
              image.sizes = '(min-width: 1080px) 290px, (min-width: 768px) 30vw, 46vw';
              imageLink.append(image);
            }
            if (image) {
              image.width = Number(purchase.image.width) || 640;
              image.height = Number(purchase.image.height) || 640;
              if (purchase.image.srcset) image.srcset = purchase.image.srcset;
              else image.removeAttribute('srcset');
              if (image.src !== source.href) image.src = source.href;
            }
            if (imageLink && fallback) imageLink.href = fallback.href;
          }
        }
      }
    }
    changeChoice(select) {
      const card = select.closest('[data-gift-card]');
      const state = this.purchases.get(card.dataset.id);
      if (!state || this.constructor.cartBusy) return;
      const selects = [...card.querySelectorAll('[data-gift-option]')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
      state.selectedIds = selects.map(node => node.value);
      state.selectionUrl = select.selectedOptions[0]?.dataset.productUrl || state.url;
      state.result = '';
      state.message = '';
      state.drawerPending = false;
      this.resolveChoice(state);
    }
    async resolveChoice(state) {
      if (this.constructor.cartBusy) return;
      state.controller?.abort();
      const generation = ++state.generation;
      const controller = new AbortController();
      state.controller = controller;
      state.phase = 'loading';
      this.paintState(state);
      let timeout;
      try {
        const url = this.productUrl(state.selectionUrl);
        const key = this.selectionKey(url, state.selectedIds);
        let purchase = state.cache.get(key);
        if (!purchase) {
          url.searchParams.delete('variant');
          url.searchParams.set('section_id', 'tt-gift-variant-data');
          url.searchParams.set('option_values', state.selectedIds.join(','));
          timeout = window.setTimeout(() => controller.abort(), 12000);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('Choice request failed');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const node = parsed.querySelector('[data-gift-variant-json]');
          if (!node) throw new Error('Choice data missing');
          const data = JSON.parse(node.textContent);
          if (data.version !== 1 || data.currency !== this.dataset.currency || data.country !== this.dataset.country || data.locale !== this.dataset.locale || !this.validPurchase(data.purchase) || String(data.product_id) !== String(data.purchase.product_id)) throw new Error('Choice context mismatch');
          purchase = data.purchase;
          if (this.selectedIds(purchase).join(',') !== state.selectedIds.join(',')) throw new Error('Choice selection mismatch');
        }
        if (generation !== state.generation || !this.isConnected) return;
        state.purchase = purchase;
        state.phase = 'ready';
        url.searchParams.delete('section_id');
        url.searchParams.delete('option_values');
        url.searchParams.delete('variant');
        state.url = url.href;
        state.cache.set(key, purchase);
        if (state.cache.size > 8) state.cache.delete(state.cache.keys().next().value);
        this.paintState(state);
      } catch {
        if (generation !== state.generation || !this.isConnected) return;
        state.phase = 'error';
        this.paintState(state);
      } finally {
        window.clearTimeout(timeout);
      }
    }
    bindGiftReady(options) {
      this.readyDialog = this.querySelector('[data-gift-ready]');
      this.readyContent = this.querySelector('[data-gift-ready-content]');
      this.readyStatus = this.querySelector('[data-gift-ready-status]');
      this.readyConfirm = this.querySelector('[data-gift-ready-confirm]');
      this.readySkip = this.querySelector('[data-gift-ready-skip]');
      this.readyRetry = this.querySelector('[data-gift-ready-retry]');
      this.readyCart = this.querySelector('[data-gift-ready-cart]');
      this.readyClose = this.querySelector('[data-gift-ready-close]');
      this.readyTotal = this.querySelector('[data-gift-ready-total]');
      this.readyClose.addEventListener('click', () => this.closeGiftReady(), options);
      this.readyDialog.addEventListener('cancel', event => { event.preventDefault(); this.closeGiftReady(); }, options);
      this.readyDialog.addEventListener('click', event => {
        if (event.target !== this.readyDialog) return;
        const box = this.readyDialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.closeGiftReady();
      }, options);
      this.readyConfirm.addEventListener('click', () => this.submitGiftReady(false), options);
      this.readySkip.addEventListener('click', () => this.submitGiftReady(true), options);
      this.readyRetry.addEventListener('click', () => this.loadGiftReady(), options);
      this.readyDialog.addEventListener('tt:gift-bag-change', () => this.paintGiftReady(), options);
    }
    startGiftReady(state, trigger) {
      const purchase = state.purchase;
      if (this.constructor.cartBusy || this.readyContext || state.phase !== 'ready' || state.result === 'uncertain' || !purchase.variant_id || !purchase.available || purchase.requires_selling_plan) return;
      if (typeof this.readyDialog.showModal !== 'function') { this.addGift(state, trigger); return; }
      this.readyContext = { state, trigger, variantId: String(purchase.variant_id), productId: String(purchase.product_id), generation: state.generation, submitting: false };
      const card = trigger.closest('[data-gift-card]');
      this.querySelector('[data-gift-ready-name]').textContent = card?.querySelector('h3')?.textContent || '';
      this.querySelector('[data-gift-ready-choice]').textContent = purchase.options.map(option => option.values.find(value => value.selected)?.name).filter(Boolean).join(' / ');
      this.querySelector('[data-gift-ready-price]').textContent = purchase.price_text;
      const image = this.querySelector('[data-gift-ready-image]');
      const source = card?.querySelector('[data-gift-image]');
      image.hidden = !source;
      if (source) image.src = source.currentSrc || source.src;
      this.readyContent.replaceChildren();
      this.readyContent.inert = false;
      this.readyCart.hidden = true;
      this.readyClose.disabled = false;
      this.readySkip.disabled = false;
      this.readySkip.hidden = false;
      this.readyConfirm.hidden = true;
      this.readyTotal.hidden = true;
      this.readyScrollLock = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.readyDialog.showModal();
      this.readyClose.focus();
      this.loadGiftReady();
    }
    closeGiftReady(force = false) {
      const context = this.readyContext;
      if (!context || (context.submitting && !force)) return;
      this.readyContext = null;
      this.readyRequest?.abort();
      this.readyDialog.close();
      this.readyContent.replaceChildren();
      document.documentElement.style.overflow = this.readyScrollLock || '';
      this.cartTrigger(context.state, context.trigger)?.focus();
    }
    async loadGiftReady() {
      const context = this.readyContext;
      if (!context || context.submitting) return;
      this.readyRequest?.abort();
      const controller = new AbortController();
      this.readyRequest = controller;
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      this.readyContent.replaceChildren();
      this.readyStatus.textContent = this.strings.readyLoading;
      this.readyStatus.hidden = false;
      this.readyRetry.hidden = true;
      this.readyConfirm.hidden = true;
      this.readyTotal.hidden = true;
      try {
        const url = this.productUrl(context.state.url);
        url.searchParams.delete('option_values');
        url.searchParams.set('variant', context.variantId);
        url.searchParams.set('section_id', 'tt-gift-ready-data');
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) throw new Error('Gift options request failed');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const responseNode = parsed.querySelector('[data-gift-ready-response]');
        const data = responseNode?.dataset;
        if (!data || data.productId !== context.productId || data.variantId !== context.variantId || data.currency !== this.dataset.currency || data.country !== this.dataset.country || data.locale !== this.dataset.locale) throw new Error('Gift options context mismatch');
        if (this.readyContext !== context || this.readyRequest !== controller || controller.signal.aborted || !this.isConnected) return;
        const widget = responseNode.querySelector('tt-gift-bag');
        if (!widget) {
          const { state, trigger } = context;
          this.closeGiftReady();
          await this.addGift(state, trigger);
          return;
        }
        if (!customElements.get('tt-gift-bag')) {
          await Promise.race([customElements.whenDefined('tt-gift-bag'), new Promise((_, reject) => controller.signal.addEventListener('abort', () => reject(new Error('Gift options unavailable')), { once: true }))]);
        }
        if (this.readyContext !== context || this.readyRequest !== controller || controller.signal.aborted || !this.isConnected) return;
        this.querySelector('[data-gift-ready-name]').textContent = data.productTitle;
        this.querySelector('[data-gift-ready-choice]').textContent = data.variantTitle === 'Default Title' ? '' : data.variantTitle;
        const imported = document.importNode(widget, true);
        const stagingNote = imported.querySelector('.tt-giftbag__staging-note');
        if (stagingNote) stagingNote.textContent = this.strings.readyStaging;
        this.readyContent.append(imported);
        if (typeof imported.getSelections !== 'function') throw new Error('Gift options unavailable');
        this.readyStatus.hidden = true;
        this.readyConfirm.hidden = false;
        this.paintGiftReady();
      } catch {
        if (this.readyContext !== context || this.readyRequest !== controller || context.submitting || !this.isConnected) return;
        this.readyContent.replaceChildren();
        this.readyStatus.textContent = this.strings.readyError;
        this.readyStatus.hidden = false;
        this.readyRetry.hidden = false;
      } finally {
        window.clearTimeout(timeout);
      }
    }
    paintGiftReady() {
      const context = this.readyContext;
      const widget = this.readyContent.querySelector('tt-gift-bag');
      if (!context || context.submitting || !widget?.getSelections) return;
      const selections = widget.getSelections();
      const count = selections.reduce((total, item) => total + item.quantity, 0);
      const total = widget.parseMoney(context.state.purchase.price_text) + selections.reduce((sum, item) => sum + widget.parseMoney(item.priceMoney) * item.quantity, 0);
      this.readyTotal.textContent = this.text('readyTotal', { total: widget.formatMoney(total) });
      this.readyTotal.hidden = false;
      this.readyConfirm.disabled = false;
      this.readyConfirm.textContent = count ? this.text(count === 1 ? 'readyOne' : 'readyMany', { count }) : this.strings.readyNoBag;
      this.readySkip.hidden = !count;
    }
    async submitGiftReady(skipBags) {
      const context = this.readyContext;
      if (!context || context.submitting || this.constructor.cartBusy) return;
      const { state, trigger } = context;
      if (String(state.purchase.variant_id) !== context.variantId || String(state.purchase.product_id) !== context.productId || state.generation !== context.generation || state.phase !== 'ready' || state.result === 'uncertain') { this.closeGiftReady(); return; }
      const widget = this.readyContent.querySelector('tt-gift-bag');
      if (!skipBags && !widget?.getSelections) return;
      const bags = skipBags ? [] : widget.getSelections().map(({ id, quantity }) => ({ id: String(id), quantity }));
      if (bags.some(item => !/^\d+$/.test(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 99)) return;
      context.submitting = true;
      this.readyRequest?.abort();
      this.readyContent.inert = true;
      this.readyConfirm.disabled = true;
      this.readySkip.disabled = true;
      this.readyRetry.hidden = true;
      this.readyClose.disabled = true;
      this.readyStatus.textContent = this.strings.adding;
      this.readyStatus.hidden = false;
      await this.addGift(state, trigger, bags);
      if (this.readyContext !== context) return;
      context.submitting = false;
      this.readyClose.disabled = false;
      this.readyConfirm.hidden = true;
      this.readySkip.hidden = true;
      this.readyCart.hidden = false;
      this.readyStatus.textContent = [state.message, this.strings.uncertain].filter(Boolean).join(' ');
    }
    cartDrawer() {
      const kaching = typeof window.kachingCartApi?.openCart === 'function';
      const native = !kaching ? document.querySelector('cart-drawer') : null;
      const drawer = native && typeof native.getSectionsToRender === 'function' && typeof native.renderContents === 'function' ? native : null;
      const sections = drawer ? [...new Set(drawer.getSectionsToRender().map(section => section.id))].filter(id => typeof id === 'string' && /^[\w-]+$/.test(id)).slice(0, 5) : [];
      return { kaching, drawer, sections };
    }
    syncCartLock() {
      document.querySelectorAll('tt-gift-guide').forEach(guide => guide.paintPurchases?.());
    }
    cartTrigger(state, trigger) {
      const card = [...this.grid.querySelectorAll('[data-gift-card]')].find(node => node.dataset.id === state.id);
      return card?.querySelector('[data-gift-add]') || (trigger?.isConnected ? trigger : this.ageButtons?.[0]);
    }
    async openDrawer(payload, trigger, cartReady = false) {
      if (!this.isConnected) return false;
      const { kaching, drawer, sections } = this.cartDrawer();
      if (kaching) {
        document.dispatchEvent(new CustomEvent('kaching-cart:open', { bubbles: true, cancelable: true, detail: { refetchCart: !cartReady, element: trigger, cartOpenSource: 'add-to-cart' } }));
        return true;
      }
      if (!drawer || !sections.length) return false;
      const complete = data => sections.every(id => typeof data?.sections?.[id] === 'string' && data.sections[id].trim());
      if (!complete(payload)) {
        const url = new URL(window.location.pathname, window.location.origin);
        url.searchParams.set('sections', sections.join(','));
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (!response.ok) return false;
          payload = { sections: await response.json() };
        } finally {
          window.clearTimeout(timeout);
        }
      }
      if (!this.isConnected || !complete(payload)) return false;
      drawer.setActiveElement?.(trigger);
      drawer.classList.remove('is-empty');
      drawer.renderContents(payload);
      return true;
    }
    async retryDrawer(state, trigger) {
      if (state.result !== 'added' || state.drawerOpening || this.constructor.cartBusy) return;
      state.drawerOpening = true;
      this.paintState(state);
      try { state.drawerPending = !(await this.openDrawer(null, this.cartTrigger(state, trigger))); }
      catch { state.drawerPending = true; }
      finally { state.drawerOpening = false; this.paintState(state); }
    }
    async addGift(state, trigger, bagItems = []) {
      const purchase = state.purchase;
      if (this.constructor.cartBusy || state.phase !== 'ready' || state.result === 'uncertain' || !purchase.variant_id || !purchase.available || purchase.requires_selling_plan) return;
      this.constructor.cartBusy = true;
      state.adding = true;
      state.result = '';
      state.drawerPending = false;
      state.message = '';
      this.syncCartLock();
      const variantId = String(purchase.variant_id);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      let attempted = false;
      let kachingHandled = false;
      try {
        const url = new URL(this.dataset.cartAddUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid cart URL');
        const { kaching, sections } = this.cartDrawer();
        kachingHandled = kaching;
        const body = { items: [{ id: variantId, quantity: 1 }, ...bagItems] };
        if (kaching) url.searchParams.set('opens_cart', 'never');
        else if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
        attempted = true;
        const response = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), signal: controller.signal });
        if (response.ok) {
          state.result = 'added';
          state.adding = false;
          this.closeGiftReady(true);
          this.paintState(state);
          let payload = null;
          try { payload = await response.json(); } catch {}
          window.clearTimeout(timeout);
          try { state.drawerPending = !(await this.openDrawer(payload, this.cartTrigger(state, trigger), kachingHandled)); }
          catch { state.drawerPending = true; }
        } else {
          state.result = 'uncertain';
          if (response.status < 500) {
            try {
              const payload = await response.json();
              if (typeof payload.description === 'string') state.message = payload.description;
              else if (typeof payload.message === 'string') state.message = payload.message;
            } catch {}
          }
        }
      } catch {
        if (state.result === 'added') state.drawerPending = true;
        else state.result = 'uncertain';
      } finally {
        window.clearTimeout(timeout);
        state.adding = false;
        this.constructor.cartBusy = false;
        if (attempted && !(kachingHandled && state.result === 'added' && !state.drawerPending)) document.dispatchEvent(new CustomEvent('cart:refresh'));
        this.syncCartLock();
      }
    }
    text(key, replacements = {}) {
      let result = this.strings[key] || '';
      for (const [name, value] of Object.entries(replacements)) result = result.replaceAll(`[${name}]`, String(value));
      return result;
    }
    render() {
      const matches = this.catalog.filter(item =>
        (this.state.age === 'all' || item.age_groups.includes(this.state.age)) &&
        (this.state.interest === 'all' || item.interests.includes(this.state.interest)) &&
        (this.state.type === 'all' || item.gift_type === this.state.type) &&
        (this.state.budget === null || item.price <= Math.round(this.state.budget * 100))
      );
      if (this.state.offset >= matches.length) this.state.offset = 0;
      const end = Math.min(matches.length, this.state.offset + this.state.shown);
      const fragment = document.createDocumentFragment();
      matches.slice(this.state.offset, end).forEach(item => fragment.append(this.card(item)));
      this.grid.replaceChildren(fragment);
      this.grid.hidden = false;
      this.grid.removeAttribute('aria-busy');
      this.pagination.hidden = true;
      this.loadStatus.hidden = true;
      this.empty.hidden = matches.length > 0;
      this.count.textContent = matches.length ? this.text('range', { from: this.state.offset + 1, to: end, total: matches.length }) : this.strings.empty;
      const remaining = matches.length - end;
      this.more.hidden = remaining <= 0;
      this.querySelector('[data-gift-more]').textContent = this.text('more', { count: Math.min(24, remaining) });
      this.querySelector('[data-gift-remaining]').textContent = this.text('remaining', { count: remaining });
    }
    card(item) {
      const make = (tag, className, text) => {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      };
      const prefix = 'tt-gift-guide__';
      const article = make('article', `${prefix}card`);
      article.dataset.giftCard = '';
      article.dataset.id = item.id;
      article.dataset.age = item.age_groups.join('|');
      article.dataset.interest = item.interests.join('|');
      article.dataset.giftType = item.gift_type;
      article.dataset.available = String(item.available);
      article.dataset.price = item.price;
      const titleId = `GiftTitle-${this.dataset.sectionId}-${item.id}`;
      article.setAttribute('aria-labelledby', titleId);
      const imageLink = make('a', `${prefix}image-link`);
      imageLink.dataset.giftImageLink = '';
      imageLink.href = item.url;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      if (item.image?.src) {
        const source = new URL(item.image.src, window.location.origin);
        if (source.protocol === 'https:' || source.origin === window.location.origin) {
          const img = make('img', `${prefix}product-image`);
          img.dataset.giftImage = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.width = Number(item.image.width) || 640;
          img.height = Number(item.image.height) || 640;
          img.alt = '';
          img.sizes = '(min-width: 1080px) 290px, (min-width: 768px) 30vw, 46vw';
          if (item.image.srcset) img.srcset = item.image.srcset;
          img.src = source.href;
          imageLink.append(img);
        }
      }
      const body = make('div', `${prefix}card-body`);
      const labels = Array.isArray(item.labels) ? [...item.labels] : [];
      if (!item.available && !labels.includes(this.strings.unavailable)) labels.push(this.strings.unavailable);
      if (labels.length) {
        const labelRow = make('div', `${prefix}labels`);
        labels.forEach(label => labelRow.append(make('span', '', label)));
        body.append(labelRow);
      }
      if (item.age_note) body.append(make('p', `${prefix}age-note`, item.age_note));
      const heading = make('h3');
      heading.id = titleId;
      const title = make('a', '', item.title);
      title.href = item.url;
      heading.append(title);
      body.append(heading);
      if (item.reason) body.append(make('p', `${prefix}reason`, item.reason));
      if (item.contents || item.setup) {
        const details = make('details', `${prefix}details`);
        const summary = make('summary', '', this.strings.before);
        const plus = make('span', '', '+');
        plus.setAttribute('aria-hidden', 'true');
        summary.append(plus);
        details.append(summary);
        const content = make('div');
        for (const key of ['contents', 'setup']) if (item[key]) {
          const paragraph = make('p');
          paragraph.append(make('strong', '', `${this.strings[key]} `), document.createTextNode(item[key]));
          content.append(paragraph);
        }
        details.append(content);
        body.append(details);
      }
      const price = make('p', `${prefix}price`);
      price.dataset.giftPrice = '';
      if (item.price_varies) price.append(make('span', `${prefix}from`, this.strings.from));
      price.append(make('span', '', item.price_text));
      if (item.compare_at > item.price && item.compare_at_text) price.append(make('s', '', item.compare_at_text));
      body.append(price);
      const purchaseWrapper = make('div', `${prefix}purchase`);
      purchaseWrapper.dataset.giftPurchase = '';
      purchaseWrapper.hidden = true;
      body.append(purchaseWrapper);
      const link = make('a', `${prefix}button ${prefix}card-button`, this.strings.view);
      link.dataset.giftFallback = '';
      link.href = item.url;
      link.setAttribute('aria-label', this.text('viewNamed', { product: item.title }));
      const arrow = make('span', '', '↗');
      arrow.setAttribute('aria-hidden', 'true');
      link.append(arrow);
      body.append(link);
      article.append(imageLink, body);
      try {
        const state = this.purchaseState(item.id, item.purchase, item.url);
        if (state) this.paintPurchase(article, state);
      } catch {}
      return article;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tibatoes-trace-grow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-trace-grow')) {
    customElements.define('tt-trace-grow', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        const config = this.querySelector('[data-tg-config]');
        if (!config) return;
        try { this.config = JSON.parse(config.textContent); } catch (_) { return; }
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.querySelectorAll('[data-tg-country-flag]').forEach((flag) => {
          const iso = (flag.getAttribute('data-tg-country-flag') || '').toUpperCase();
          if (!/^[A-Z]{2}$/.test(iso)) return;
          const first = 0x1F1E6 + iso.charCodeAt(0) - 65;
          const second = 0x1F1E6 + iso.charCodeAt(1) - 65;
          flag.textContent = String.fromCodePoint(first) + String.fromCodePoint(second);
        });
        this.form = this.querySelector('.tt-tg__form');
        this.variantInput = this.querySelector('[data-tg-variant]');
        this.submit = this.querySelector('[data-tg-submit]');
        this.submitText = this.querySelector('[data-tg-submit-text]');
        this.error = this.querySelector('[data-tg-error]');
        this.status = this.querySelector('[data-tg-form-status]');
        this.cartFallback = this.querySelector('[data-tg-cart-fallback]');
        this.slides = Array.from(this.querySelectorAll('[data-tg-slide]'));
        this.thumbnails = Array.from(this.querySelectorAll('[data-tg-thumbnail]'));
        this.imageIndex = 0;
        this.querySelector('[data-tg-gallery-controls]')?.removeAttribute('hidden');
        this.thumbnails.forEach((link, index) => link.addEventListener('click', (event) => {
          event.preventDefault();
          this.showImage(index);
        }, { signal }));
        this.querySelector('[data-tg-previous]')?.addEventListener('click', () => this.showImage(this.imageIndex - 1), { signal });
        this.querySelector('[data-tg-next]')?.addEventListener('click', () => this.showImage(this.imageIndex + 1), { signal });
        this.querySelector('[data-tg-gallery]')?.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showImage(this.imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
          this.thumbnails[this.imageIndex]?.focus({ preventScroll: true });
        }, { signal });
        const stage = this.querySelector('.tt-tg__gallery-stage');
        stage?.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch' || event.target.closest('button, a')) return;
          this.swipeStart = { x: event.clientX, y: event.clientY, pointerId: event.pointerId };
          stage.setPointerCapture(event.pointerId);
        }, { signal });
        stage?.addEventListener('pointerup', (event) => {
          if (!this.swipeStart || this.swipeStart.pointerId !== event.pointerId) return;
          const dx = event.clientX - this.swipeStart.x;
          const dy = event.clientY - this.swipeStart.y;
          this.swipeStart = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.showImage(this.imageIndex + (dx < 0 ? 1 : -1));
        }, { signal });
        stage?.addEventListener('pointercancel', () => { this.swipeStart = null; }, { signal });
        this.variantInput?.addEventListener('change', () => this.updateVariant(), { signal });
        if (this.form && window.fetch) this.form.addEventListener('submit', (event) => this.addToCart(event), { signal });
        this.querySelectorAll('a[href="#' + this.id + '-buy"]').forEach((link) => link.addEventListener('click', (event) => {
          event.preventDefault();
          this.querySelector('.tt-tg__buy').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          this.submit?.focus({ preventScroll: true });
        }, { signal }));
        this.querySelector('[data-tg-review-link]')?.addEventListener('click', (event) => {
          const target = this.querySelector('[data-tg-reviews]');
          if (!target) return;
          event.preventDefault();
          const header = this.querySelector('.tt-tg-header-wrap') || document.querySelector('sticky-header');
          const offset = header ? header.getBoundingClientRect().height + 16 : 16;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          target.focus({ preventScroll: true });
          window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
        this.sticky = this.querySelector('[data-tg-sticky]');
        if (this.sticky && this.form && 'IntersectionObserver' in window) {
          const footer = document.querySelector('#shopify-section-tibatoes-footer') || document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
          this.formVisible = true;
          this.rootVisible = true;
          this.footerVisible = false;
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === this.form) this.formVisible = entry.isIntersecting;
              if (entry.target === this) this.rootVisible = entry.isIntersecting;
              if (entry.target === footer) this.footerVisible = entry.isIntersecting;
            });
            this.sticky.hidden = this.formVisible || this.footerVisible || !this.rootVisible;
          }, { threshold: 0 });
          this.observer.observe(this.form);
          this.observer.observe(this);
          if (footer && !this.contains(footer)) this.observer.observe(footer);
        }
        this.tabs = Array.from(this.querySelectorAll('[data-tg-tab]'));
        this.tabPanels = Array.from(this.querySelectorAll('[data-tg-tab-panel]'));
        this.querySelector('[data-tg-tabs]')?.removeAttribute('hidden');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.showTab(index), { signal });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.showTab(next);
            this.tabs[next].focus();
          }, { signal });
        });
        this.showTab(0);
        this.setupOffers(signal);
        this.updateVariant();
        this.setupUGCVideos(signal);
        this.setupReviews();
      }

      disconnectedCallback() {
        this.ugcCleanup?.();
        this.ugcCleanup = null;
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
      }

      setupOffers(signal) {
        this.offerRadios = Array.from(this.querySelectorAll('[data-tg-quantity-option]'));
        this.offerCards = Array.from(this.querySelectorAll('[data-tg-offer-card]'));
        this.discountRules = { 1: { type: 'default', value: 0 }, 2: { type: 'default', value: 0 } };
        this.roundingCents = -1;
        const sample = this.config.moneyLarge;
        const numeric = sample.match(/\d[\d.,\s]*/)?.[0]?.trim() || '1,234,567.89';
        const zeroNumeric = this.config.moneyZero.match(/\d[\d.,]*/)?.[0] || '0.00';
        const decimals = zeroNumeric.match(/[.,](\d+)$/)?.[1]?.length || 0;
        const decimalSeparator = decimals ? numeric.slice(-decimals - 1, -decimals) : '';
        const whole = decimals ? numeric.slice(0, -decimals - 1) : numeric;
        this.moneyLayout = { decimals, decimalSeparator, thousandsSeparator: whole.match(/[^\d]/)?.[0] || '', prefix: sample.slice(0, sample.indexOf(numeric)), suffix: sample.slice(sample.indexOf(numeric) + numeric.length) };
        this.addEventListener('tt:gift-bag-change', () => this.updatePurchaseState(), { signal });
        this.offerRadios.forEach((radio) => radio.addEventListener('change', () => {
          if (!radio.checked) return;
          this.refreshOfferPrices();
          this.updatePurchaseState();
        }, { signal }));
        if (!this.readOfferDiscounts(document)) this.loadOfferDiscounts(signal);
        window.addEventListener('load', () => {
          this.readOfferDiscounts(document);
          this.refreshOfferPrices();
          this.updatePurchaseState();
        }, { signal, once: true });
      }

      async loadOfferDiscounts(signal) {
        try {
          const url = new URL(this.config.productUrl, location.origin);
          if (url.origin !== location.origin) return;
          const response = await fetch(url.pathname + url.search, { credentials: 'same-origin', headers: { Accept: 'text/html' }, signal });
          if (!response.ok) return;
          const source = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || signal?.aborted || !this.readOfferDiscounts(source)) return;
          this.refreshOfferPrices();
          this.updatePurchaseState();
        } catch (_) {}
      }

      readOfferDiscounts(source) {
        const deals = [];
        for (const script of source.querySelectorAll('script.kaching-bundles-deal-block-settings')) {
          try { deals.push(JSON.parse(script.textContent)); } catch (_) {}
        }
        const currentMarket = String(this.config.marketId || '').split('/').pop();
        deals.sort((left, right) => {
          const leftMatch = String(left?.marketId || '').split('/').pop() === currentMarket && Boolean(currentMarket);
          const rightMatch = String(right?.marketId || '').split('/').pop() === currentMarket && Boolean(currentMarket);
          return Number(rightMatch) - Number(leftMatch);
        });
        return deals.some((deal) => this.applyOfferDiscounts(deal));
      }

      applyOfferDiscounts(deal) {
        if (!deal || !Array.isArray(deal.dealBars) || !Array.isArray(deal.selectedProductIds)) return false;
        if (!deal.selectedProductIds.some((id) => String(id).split('/').pop() === this.config.productId)) return false;
        const currentMarket = String(this.config.marketId || '').split('/').pop();
        const dealMarket = String(deal.marketId || '').split('/').pop();
        if (dealMarket && dealMarket !== currentMarket) return false;
        if (Array.isArray(deal.excludedMarketIds) && deal.excludedMarketIds.some((id) => String(id).split('/').pop() === currentMarket)) return false;
        if (![1, 2].every((quantity) => deal.dealBars.some((bar) => Number(bar.quantity) === quantity))) return false;
        const rules = { 1: { type: 'default', value: 0 }, 2: { type: 'default', value: 0 } };
        deal.dealBars.forEach((bar) => {
          const quantity = Number(bar.quantity);
          const value = Number(bar.discountValue);
          if ((quantity !== 1 && quantity !== 2) || !Number.isFinite(value) || value < 0) return;
          if (['default', 'amount', 'percentage'].includes(bar.discountType)) rules[quantity] = { type: bar.discountType, value: bar.discountType === 'percentage' ? Math.min(100, value) : value };
        });
        this.discountRules = rules;
        const rounding = String(deal.priceRoundingPrecision || '').match(/\.(\d{2})/);
        this.roundingCents = deal.priceRounding && rounding ? Number(rounding[1]) : -1;
        this.querySelector('[data-tg-offers]')?.setAttribute('data-pricing-source', 'kaching');
        return true;
      }

      selectedOfferQuantity() {
        return this.offerRadios?.find((radio) => radio.checked)?.value === '2' ? 2 : 1;
      }

      presentmentRate() {
        if (this.config.cartCurrency === this.config.shopCurrency) return 1;
        const rate = Number(window.Shopify?.currency?.rate);
        return Number.isFinite(rate) && rate > 0 ? rate : null;
      }

      offerPrice(quantity) {
        const regular = Number(this.variant?.priceAmount || 0) * quantity;
        const compare = Math.max(Number(this.variant?.compareAmount || 0), Number(this.variant?.priceAmount || 0)) * quantity;
        const rule = this.discountRules?.[quantity] || { type: 'default', value: 0 };
        let discount = 0;
        if (rule.type === 'percentage') discount = Math.round(regular * rule.value / 100);
        if (rule.type === 'amount') {
          const rate = this.presentmentRate();
          if (rate !== null) discount = Math.round(rule.value * rate * 100) * quantity;
        }
        let price = Math.max(0, regular - discount);
        if (price > 0 && discount > 0 && this.roundingCents >= 0 && this.moneyLayout?.decimals === 2) price = Math.min(regular, Math.floor(price / 100) * 100 + this.roundingCents);
        return { price, compare, saving: Math.max(0, compare - price) };
      }

      formatOfferMoney(amount) {
        const layout = this.moneyLayout;
        if (!layout) return this.variant?.price || '';
        const parts = (Math.max(0, Math.round(amount)) / 100).toFixed(layout.decimals).split('.');
        const whole = layout.thousandsSeparator ? parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, layout.thousandsSeparator) : parts[0];
        return layout.prefix + whole + (layout.decimals ? layout.decimalSeparator + parts[1] : '') + layout.suffix;
      }

      refreshOfferPrices() {
        if (!this.variant) return;
        this.offerCards?.forEach((card) => {
          const offer = this.offerPrice(Number(card.dataset.tgOfferCard));
          card.querySelector('[data-tg-offer-price]').textContent = this.formatOfferMoney(offer.price);
          const compare = card.querySelector('[data-tg-offer-compare]');
          compare.textContent = this.formatOfferMoney(offer.compare);
          compare.hidden = offer.compare <= offer.price;
          const saving = card.querySelector('[data-tg-offer-save]');
          saving.textContent = this.config.strings.save.replace('[amount]', this.formatOfferMoney(offer.saving));
          saving.hidden = offer.saving <= 0;
        });
      }

      selectedGiftBags() {
        const giftBag = this.querySelector('tt-gift-bag');
        const selections = typeof giftBag?.getSelections === 'function' ? giftBag.getSelections() : [];
        return selections.filter((bag) => Number.isSafeInteger(Number(bag.id)) && Number(bag.id) > 0 && Number.isSafeInteger(Number(bag.quantity)) && Number(bag.quantity) > 0 && Number.isFinite(Number(bag.price)) && Number(bag.price) >= 0).map((bag) => ({ id: Number(bag.id), quantity: Number(bag.quantity), price: Number(bag.price), compare: Math.max(Number(bag.compare) || 0, Number(bag.price)) }));
      }

      purchaseTotals() {
        const offer = this.offerPrice(this.selectedOfferQuantity());
        return this.selectedGiftBags().reduce((total, bag) => ({ price: total.price + bag.price * bag.quantity, compare: total.compare + bag.compare * bag.quantity }), { price: offer.price, compare: offer.compare });
      }

      updatePurchaseState() {
        const available = Boolean(this.variant?.available);
        const offer = this.offerPrice(this.selectedOfferQuantity());
        const total = this.purchaseTotals();
        this.submit.disabled = this.busy || !available;
        this.submitText.textContent = this.busy ? this.config.strings.adding : !available ? this.config.strings.soldOut : this.config.strings.claimOffer;
        this.querySelectorAll('[data-tg-price]').forEach((price) => { price.textContent = this.formatOfferMoney(offer.price); });
        const compare = this.querySelector('[data-tg-main-compare]');
        if (compare) { compare.textContent = this.formatOfferMoney(offer.compare); compare.hidden = offer.compare <= offer.price; }
        const saving = this.querySelector('[data-tg-main-save]');
        const percentage = offer.compare > offer.price ? Math.round((offer.compare - offer.price) * 100 / offer.compare) : 0;
        if (saving) { saving.textContent = this.config.strings.savePercent.replace('[percent]', String(percentage)); saving.hidden = percentage <= 0; }
        const buttonPrices = this.querySelector('[data-tg-submit-prices]');
        if (buttonPrices) buttonPrices.hidden = this.busy || !available;
        const buttonTotal = this.querySelector('[data-tg-submit-total]');
        if (buttonTotal) buttonTotal.textContent = this.formatOfferMoney(total.price);
        const buttonCompare = this.querySelector('[data-tg-submit-compare]');
        if (buttonCompare) { buttonCompare.textContent = this.formatOfferMoney(total.compare); buttonCompare.hidden = total.compare <= total.price; }
        const stock = this.querySelector('[data-tg-stock]');
        if (stock) stock.textContent = available ? this.config.strings.available : this.config.strings.soldOut;
      }

      selectedFreeGifts() {
        const quantity = this.selectedOfferQuantity();
        return (this.config.freeGifts || []).filter((gift) => gift.available && Number.isSafeInteger(Number(gift.id)) && Number(gift.id) > 0 && Number(gift.threshold) <= quantity).map((gift) => ({ id: Number(gift.id), quantity: 1, properties: { _free_gift: 'true' } }));
      }

      buildCartPayload() {
        return { items: [{ id: Number(this.variant.id), quantity: this.selectedOfferQuantity() }, ...this.selectedGiftBags().map((bag) => ({ id: bag.id, quantity: bag.quantity })), ...this.selectedFreeGifts()] };
      }

      cartDiscountCodes(cart) {
        const codes = new Map();
        const remember = (code) => {
          if (typeof code === 'string' && code.trim()) codes.set(code.trim().toUpperCase(), code.trim());
        };
        (cart.discount_codes || []).forEach((discount) => remember(discount.code));
        const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application))];
        applications.forEach((application) => { if (application?.type === 'discount_code') remember(application.title); });
        remember(this.config.giftDiscountCode);
        return Array.from(codes.values()).join(',');
      }

      giftLines(cart, gift) {
        return (cart?.items || []).filter((item) => Number(item.variant_id || item.id) === gift.id && String(item.properties?._free_gift) === 'true');
      }

      giftsAreFree(cart, gifts, before) {
        return gifts.every((gift) => {
          const lines = this.giftLines(cart, gift);
          const previousQuantity = this.giftLines(before, gift).reduce((sum, item) => sum + Number(item.quantity), 0);
          return lines.reduce((sum, item) => sum + Number(item.quantity), 0) >= previousQuantity + gift.quantity && lines.every((item) => Number.isFinite(item.final_line_price) && item.final_line_price === 0);
        });
      }

      async readCart() {
        const response = await fetch(this.config.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('cart-read');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('cart-read');
        return cart;
      }

      async updateCart(data, kachingHandled = false) {
        const url = new URL(this.config.cartUpdateUrl, window.location.origin);
        if (kachingHandled) url.searchParams.set('opens_cart', 'never');
        const response = await fetch(url.href, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
        const cart = await response.json();
        if (!response.ok || cart.status || !Array.isArray(cart.items)) throw new Error('cart-update');
        return cart;
      }

      async removeAddedGifts(gifts, before) {
        const cart = await this.readCart();
        const updates = {};
        gifts.forEach((gift) => {
          const lines = this.giftLines(cart, gift);
          const previousQuantity = this.giftLines(before, gift).reduce((sum, item) => sum + Number(item.quantity), 0);
          const currentQuantity = lines.reduce((sum, item) => sum + Number(item.quantity), 0);
          let remaining = Math.min(gift.quantity, Math.max(0, currentQuantity - previousQuantity));
          lines.slice().reverse().forEach((item) => {
            const remove = Math.min(remaining, Number(item.quantity));
            if (remove > 0) updates[item.key] = Number(item.quantity) - remove;
            remaining -= remove;
          });
        });
        const result = Object.keys(updates).length ? await this.updateCart({ updates }) : cart;
        return gifts.every((gift) => this.giftLines(result, gift).reduce((sum, item) => sum + Number(item.quantity), 0) <= this.giftLines(before, gift).reduce((sum, item) => sum + Number(item.quantity), 0));
      }

      setupUGCVideos(signal) {
        var gallery = this.querySelector('[data-tg-ugc]');
        if (!gallery) return;
        var track = gallery.querySelector('[data-tg-ugc-track]');
        var nav = gallery.querySelector('[data-tg-ugc-nav]');
        var previous = gallery.querySelector('[data-tg-ugc-previous]');
        var next = gallery.querySelector('[data-tg-ugc-next]');
        var dialog = gallery.querySelector('[data-tg-ugc-dialog]');
        var player = gallery.querySelector('[data-tg-ugc-player]');
        var close = gallery.querySelector('[data-tg-ugc-close]');
        var error = gallery.querySelector('[data-tg-ugc-error]');
        var activeVideo = null;
        var opener = null;
        var scrollState = null;
        var resizeObserver = null;
        var isRTL = window.getComputedStyle(track).direction === 'rtl';

        function updateNavigation() {
          var position = Math.abs(track.scrollLeft);
          var limit = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = position <= 2;
          next.disabled = position >= limit - 2;
          nav.hidden = limit <= 2;
        }
        function move(direction) {
          var card = track.querySelector('.tt-tg-ugc__card');
          if (!card) return;
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 10;
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollBy({ left: direction * (isRTL ? -1 : 1) * (card.getBoundingClientRect().width + gap), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        function lockPage() {
          if (scrollState) return;
          var body = document.body;
          var html = document.documentElement;
          var properties = ['position', 'top', 'left', 'width', 'overflow', 'padding-right'];
          var gap = Math.max(0, window.innerWidth - html.clientWidth);
          var padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
          scrollState = { x: window.scrollX, y: window.scrollY, body: {}, overflow: html.style.getPropertyValue('overflow'), overflowPriority: html.style.getPropertyPriority('overflow') };
          properties.forEach(function(property) { scrollState.body[property] = [body.style.getPropertyValue(property), body.style.getPropertyPriority(property)]; });
          body.style.setProperty('position', 'fixed');
          body.style.setProperty('top', -scrollState.y + 'px');
          body.style.setProperty('left', -scrollState.x + 'px');
          body.style.setProperty('width', '100%');
          body.style.setProperty('overflow', 'hidden');
          body.style.setProperty('padding-right', padding + gap + 'px');
          html.style.setProperty('overflow', 'hidden');
        }
        function unlockPage() {
          if (!scrollState) return;
          var state = scrollState;
          scrollState = null;
          var body = document.body;
          var html = document.documentElement;
          Object.keys(state.body).forEach(function(property) {
            var value = state.body[property];
            if (value[0]) body.style.setProperty(property, value[0], value[1]);
            else body.style.removeProperty(property);
          });
          if (state.overflow) html.style.setProperty('overflow', state.overflow, state.overflowPriority);
          else html.style.removeProperty('overflow');
          var behavior = html.style.getPropertyValue('scroll-behavior');
          var priority = html.style.getPropertyPriority('scroll-behavior');
          html.style.setProperty('scroll-behavior', 'auto', 'important');
          window.scrollTo(state.x, state.y);
          if (behavior) html.style.setProperty('scroll-behavior', behavior, priority);
          else html.style.removeProperty('scroll-behavior');
        }
        function releaseVideo() {
          if (activeVideo) {
            activeVideo.pause();
            activeVideo.removeAttribute('src');
            activeVideo.querySelectorAll('source').forEach(function(source) { source.removeAttribute('src'); });
            activeVideo.load();
            activeVideo = null;
          }
          player.replaceChildren();
          error.hidden = true;
          unlockPage();
        }
        function closeVideo() {
          if (dialog.open) dialog.close();
          releaseVideo();
        }
        function openVideo(button) {
          if (dialog.open) return;
          var template = button.parentElement.querySelector('[data-tg-ugc-template]');
          if (!template) return;
          var fragment = template.content.cloneNode(true);
          var video = fragment.querySelector('video');
          if (!video) return;
          var connection = navigator.connection;
          var lighterSource = window.matchMedia('(max-width: 767px)').matches || (connection && (connection.saveData || /(^|-)2g$|3g/.test(connection.effectiveType)));
          var source = template.getAttribute(lighterSource ? 'data-tg-ugc-mobile-src' : 'data-tg-ugc-desktop-src');
          if (source) {
            video.querySelectorAll('source').forEach(function(item) { item.remove(); });
            video.src = source;
          }
          video.preload = 'auto';
          video.playsInline = true;
          activeVideo = video;
          player.replaceChildren(fragment);
          var videoLabel = template.getAttribute('data-tg-ugc-label');
          video.setAttribute('aria-label', videoLabel);
          dialog.setAttribute('aria-label', videoLabel);
          opener = button;
          error.hidden = true;
          video.addEventListener('error', function() { if (activeVideo === video && dialog.open) error.hidden = false; }, { once: true, signal });
          try {
            dialog.showModal();
            lockPage();
            close.focus({ preventScroll: true });
            video.muted = false;
            video.autoplay = true;
            var playRequest = video.play();
            if (playRequest && typeof playRequest.catch === 'function') {
              playRequest.catch(function(playError) {
                if (activeVideo !== video || !dialog.open) return;
                if (playError.name === 'NotAllowedError') {
                  video.muted = true;
                  var mutedRequest = video.play();
                  if (mutedRequest && typeof mutedRequest.catch === 'function') {
                    mutedRequest.catch(function(retryError) {
                      if (activeVideo === video && dialog.open && retryError.name !== 'AbortError') error.hidden = false;
                    });
                  }
                } else if (playError.name !== 'AbortError') error.hidden = false;
              });
            }
          } catch (e) { closeVideo(); }
        }
        track.hidden = false;
        previous.addEventListener('click', function() { move(-1); }, { signal });
        next.addEventListener('click', function() { move(1); }, { signal });
        track.addEventListener('scroll', updateNavigation, { passive: true, signal });
        if ('ResizeObserver' in window) {
          resizeObserver = new ResizeObserver(updateNavigation);
          resizeObserver.observe(track);
        } else window.addEventListener('resize', updateNavigation, { passive: true, signal });
        this.ugcCleanup = () => {
          closeVideo();
          if (resizeObserver) resizeObserver.disconnect();
          opener = null;
          gallery.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
            video.load();
          });
        };
        updateNavigation();
        if (typeof dialog.showModal !== 'function') {
          track.querySelectorAll('.tt-tg-ugc__card').forEach(function(card) {
            var template = card.querySelector('[data-tg-ugc-template]');
            if (template) card.replaceChildren(template.content.cloneNode(true), template);
          });
          return;
        }
        track.addEventListener('click', function(event) {
          var button = event.target.closest('[data-tg-ugc-open]');
          if (button && track.contains(button)) openVideo(button);
        }, { signal });
        close.addEventListener('click', closeVideo, { signal });
        dialog.addEventListener('cancel', function(event) { event.preventDefault(); closeVideo(); }, { signal });
        dialog.addEventListener('close', function() {
          releaseVideo();
          if (opener && opener.isConnected) opener.focus({ preventScroll: true });
          opener = null;
        }, { signal });
        dialog.addEventListener('click', function(event) {
          if (event.target !== dialog) return;
          var rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeVideo();
        }, { signal });
        function onVisibilityChange() { if (document.hidden && activeVideo) activeVideo.pause(); }
        window.addEventListener('pagehide', closeVideo, { signal });
        document.addEventListener('visibilitychange', onVisibilityChange, { signal });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(gallery)) this.ugcCleanup?.();
        }, { signal });
      }

      setupReviews() {
        if (!this.isConnected || !this.querySelector('#looxReviews') || !this.config.looxShop) return;
        if (window.LOOX?.widgetRunOnce) return;
        const existingScript = Array.from(document.scripts).some((script) => {
          if (!script.src) return false;
          try {
            const url = new URL(script.src, document.baseURI);
            return url.hostname === 'loox.io' && /^\/widget\/(?:[^/]+\/)?loox(?:\.[^/]+)?\.js$/.test(url.pathname);
          } catch (_) { return false; }
        });
        if (existingScript) return;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://loox.io/widget/loox.js?shop=' + encodeURIComponent(this.config.looxShop);
        script.dataset.ttTraceGrowLoox = '';
        document.head.appendChild(script);
      }

      showTab(index) {
        this.tabs.forEach((tab, position) => {
          const selected = index === position;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.tabPanels.forEach((panel, position) => { panel.hidden = index !== position; });
      }

      showImage(index) {
        if (!this.slides.length) return;
        this.imageIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.imageIndex; });
        this.thumbnails.forEach((link, position) => {
          if (position === this.imageIndex) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const number = this.querySelector('[data-tg-image-number]');
        if (number) number.textContent = this.imageIndex + 1;
        this.querySelector('[data-tg-gallery-status]').textContent = this.config.strings.imageStatus
          .replace('[number]', String(this.imageIndex + 1)).replace('[total]', String(this.slides.length));
      }

      updateVariant() {
        this.variant = this.config.variants.find((variant) => variant.id === this.variantInput?.value);
        this.updatePurchaseState();
        if (this.variant) {
          this.refreshOfferPrices();
          const imageIndex = this.slides.findIndex((image) => image.dataset.imageId === this.variant.imageId);
          if (imageIndex >= 0 && imageIndex !== this.imageIndex) this.showImage(imageIndex);
        }
      }

      async addToCart(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity() || !this.variant?.available) return;
        this.busy = true;
        this.error.hidden = true;
        this.error.textContent = '';
        this.status.textContent = '';
        this.cartFallback.hidden = true;
        this.form.setAttribute('aria-busy', 'true');
        this.updateVariant();
        const data = this.buildCartPayload();
        const gifts = data.items.filter((item) => item.properties?._free_gift === 'true');
        const kachingHandled = typeof window.kachingCartApi?.openCart === 'function';
        const drawer = document.querySelector('cart-drawer');
        let canRenderDrawer = typeof drawer?.renderContents === 'function' && typeof drawer?.getSectionsToRender === 'function';
        if (canRenderDrawer) {
          try {
            data.sections = drawer.getSectionsToRender().map((section) => section.id).join(',');
            data.sections_url = location.pathname;
            drawer.setActiveElement?.(this.submit);
          } catch (_) {
            canRenderDrawer = false;
            delete data.sections;
            delete data.sections_url;
          }
        }
        let before;
        let addStarted = false;
        let giftsConfirmed = !gifts.length;
        try {
          if (gifts.length) before = await this.readCart();
          addStarted = true;
          const addUrl = new URL(this.config.cartAddUrl, window.location.origin);
          if (kachingHandled) addUrl.searchParams.set(gifts.length ? 'kaching_cart_ignore' : 'opens_cart', gifts.length ? 'true' : 'never');
          const response = await fetch(addUrl.href, {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(data)
          });
          let result = await response.json();
          if (!response.ok || result.status) {
            addStarted = false;
            this.error.textContent = typeof result.description === 'string' ? result.description : this.config.strings.error;
            this.error.hidden = false;
            return;
          }
          if (gifts.length) {
            const update = { discount: this.cartDiscountCodes(before), sections_url: window.location.pathname };
            if (data.sections) { update.sections = data.sections; update.sections_url = data.sections_url; }
            result = await this.updateCart(update, kachingHandled);
            if (!this.giftsAreFree(result, gifts, before)) throw new Error('gift-discount');
            giftsConfirmed = true;
          }
          this.status.textContent = this.config.strings.added;
          this.cartFallback.hidden = false;
          const api = window.kachingCartApi;
          if (typeof api?.openCart === 'function') {
            try {
              const cart = kachingHandled && typeof api.getCartData === 'function' ? api.getCartData() : result;
              if (Array.isArray(cart?.items) && Number.isFinite(cart.item_count)) {
                this.querySelectorAll('[data-tg-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.dataset.count = cart.item_count; });
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              }
              api.openCart({ refetchCart: !kachingHandled });
              return;
            } catch (_) {}
          }
          if (canRenderDrawer && result.sections) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(result);
              const cart = Array.isArray(result.items) && Number.isFinite(result.item_count) ? result : await this.readCart();
              this.querySelectorAll('[data-tg-cart-count]').forEach((count) => { count.textContent = cart.item_count; count.dataset.count = cart.item_count; });
            } catch (_) { location.assign(this.config.cartUrl); }
          } else { location.assign(this.config.cartUrl); }
        } catch (_) {
          if (addStarted && !giftsConfirmed && before) {
            let removed = false;
            try { removed = await this.removeAddedGifts(gifts, before); } catch (_) {}
            this.error.textContent = removed ? this.config.strings.giftError : this.config.strings.giftReviewError;
          } else {
            this.error.textContent = this.config.strings.networkError;
          }
          this.error.hidden = false;
          this.cartFallback.hidden = false;
        } finally {
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          this.updateVariant();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
